let List =[
    {
        "type": "restaurant",
        "data": {
          "type": "F",
          "id": "451678",
          "name": "NOTO - Healthy Ice Cream",
          "uuid": "9b05a967-afa2-4276-9874-be1538b979ca",
          "city": "5",
          "area": "Kharghar",
          "totalRatingsString": "100+ ratings",
          "cloudinaryImageId": "51bd9c7efcc0e05c614c0e0674434e62",
          "cuisines": [
            "Ice Cream",
            "Desserts"
          ],
          "tags": [
            
          ],
          "costForTwo": 25000,
          "costForTwoString": "₹250 FOR TWO",
          "deliveryTime": 19,
          "minDeliveryTime": 19,
          "maxDeliveryTime": 19,
          "slaString": "19 MINS",
          "lastMileTravel": 4.599999904632568,
          "slugs": {
            "restaurant": "noto---healthy-ice-cream-kharghar-kharghar",
            "city": "mumbai"
          },
          "cityState": "5",
          "address": "SHOP - 39, PLOT - 28, SEC - 4, BHOOMI TOWER, KHARGHAR, Panvel (Rural), Raigad, , Maharashtra, 410210",
          "locality": "Sec - 4",
          "parentId": 7158,
          "unserviceable": false,
          "veg": true,
          "select": false,
          "favorite": false,
          "tradeCampaignHeaders": [
            
          ],
          "aggregatedDiscountInfo": {
            "header": "50% off",
            "shortDescriptionList": [
              {
                "meta": "50% off | Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "aggregatedDiscountInfoV2": {
            "header": "50% OFF",
            "shortDescriptionList": [
              {
                "meta": "Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "ribbon": [
            {
              "type": "PROMOTED"
            }
          ],
          "chain": [
            
          ],
          "feeDetails": {
            "fees": [
              
            ],
            "totalFees": 0,
            "message": "",
            "title": "",
            "amount": "",
            "icon": ""
          },
          "availability": {
            "opened": true,
            "nextOpenMessage": "",
            "nextCloseMessage": ""
          },
          "longDistanceEnabled": 0,
          "rainMode": "NONE",
          "thirdPartyAddress": false,
          "thirdPartyVendor": "",
          "adTrackingID": "cid=5857907~p=1~eid=00000186-4715-5968-37ea-e989004e011b",
          "badges": {
            "imageBased": [
              
            ],
            "textBased": [
              
            ],
            "textExtendedBadges": [
              
            ]
          },
          "lastMileTravelString": "4.5 kms",
          "hasSurge": false,
          "sla": {
            "restaurantId": "451678",
            "deliveryTime": 19,
            "minDeliveryTime": 19,
            "maxDeliveryTime": 19,
            "lastMileTravel": 4.599999904632568,
            "lastMileDistance": 0,
            "serviceability": "SERVICEABLE",
            "rainMode": "NONE",
            "longDistance": "NOT_LONG_DISTANCE",
            "preferentialService": false,
            "iconType": "EMPTY"
          },
          "promoted": true,
          "avgRating": "4.4",
          "totalRatings": 100,
          "new": false
        },
        "subtype": "basic"
      },
      {
        "type": "restaurant",
        "data": {
          "type": "F",
          "id": "242586",
          "name": "The Belgian Waffle Co.",
          "uuid": "28178767-d6fb-409a-8609-d8be4db5e559",
          "city": "5",
          "area": "Kalamboli",
          "totalRatingsString": "100+ ratings",
          "cloudinaryImageId": "idqw4a8gcvardctb0ldr",
          "cuisines": [
            "Waffle",
            "Desserts",
            "Ice Cream"
          ],
          "tags": [
            
          ],
          "costForTwo": 20000,
          "costForTwoString": "₹200 FOR TWO",
          "deliveryTime": 28,
          "minDeliveryTime": 28,
          "maxDeliveryTime": 28,
          "slaString": "28 MINS",
          "lastMileTravel": 0.6000000238418579,
          "slugs": {
            "restaurant": "the-belgian-waffle-co-kalamboli-kalamboli",
            "city": "mumbai"
          },
          "cityState": "5",
          "address": "Shop no . 30. MatruChaya CHS, plot no 21. sector 11, 410218.kalmaboli",
          "locality": "MatruChaya",
          "parentId": 2233,
          "unserviceable": false,
          "veg": true,
          "select": false,
          "favorite": false,
          "tradeCampaignHeaders": [
            
          ],
          "aggregatedDiscountInfo": {
            "header": "20% off",
            "shortDescriptionList": [
              {
                "meta": "20% off | Use TRYNEW",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "20% off up to ₹50 | Use code TRYNEW",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "aggregatedDiscountInfoV2": {
            "header": "20% OFF",
            "shortDescriptionList": [
              {
                "meta": "Use TRYNEW",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "20% off up to ₹50 | Use code TRYNEW",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "chain": [
            
          ],
          "feeDetails": {
            "fees": [
              
            ],
            "totalFees": 0,
            "message": "",
            "title": "",
            "amount": "",
            "icon": ""
          },
          "availability": {
            "opened": true,
            "nextOpenMessage": "",
            "nextCloseMessage": ""
          },
          "longDistanceEnabled": 0,
          "rainMode": "NONE",
          "thirdPartyAddress": false,
          "thirdPartyVendor": "",
          "adTrackingID": "",
          "badges": {
            "imageBased": [
              
            ],
            "textBased": [
              
            ],
            "textExtendedBadges": [
              
            ]
          },
          "lastMileTravelString": "0.6 kms",
          "hasSurge": false,
          "sla": {
            "restaurantId": "242586",
            "deliveryTime": 28,
            "minDeliveryTime": 28,
            "maxDeliveryTime": 28,
            "lastMileTravel": 0.6000000238418579,
            "lastMileDistance": 0,
            "serviceability": "SERVICEABLE",
            "rainMode": "NONE",
            "longDistance": "NOT_LONG_DISTANCE",
            "preferentialService": false,
            "iconType": "EMPTY"
          },
          "promoted": false,
          "avgRating": "4.1",
          "totalRatings": 100,
          "new": false
        },
        "subtype": "basic"
      },
      {
        "type": "restaurant",
        "data": {
          "type": "F",
          "id": "257839",
          "name": "HOTEL SAI POOJA",
          "uuid": "e53e968c-4a7e-4d26-b948-669fa8dfe6ff",
          "city": "5",
          "area": "Panvel",
          "totalRatingsString": "20+ ratings",
          "cloudinaryImageId": "a0vni3s9mzi0pcl5dnfk",
          "cuisines": [
            "Maharashtrian",
            "North Indian",
            "Biryani",
            "Snacks",
            "Thalis",
            "Seafood"
          ],
          "tags": [
            
          ],
          "costForTwo": 20000,
          "costForTwoString": "₹200 FOR TWO",
          "deliveryTime": 28,
          "minDeliveryTime": 28,
          "maxDeliveryTime": 28,
          "slaString": "28 MINS",
          "lastMileTravel": 1.2999999523162842,
          "slugs": {
            "restaurant": "hotel-sai-pooja-kamothe-kamothe",
            "city": "mumbai"
          },
          "cityState": "5",
          "address": "SHOP NO 18 JUHI GARDEN CHS PLOT NO 08 SECTOR 07 KAMOTHE, PANVEL (RURAL), RAIGAD, (MAHARASHTRA), - 410209, Netambit - 410209",
          "locality": "Juhi Garden",
          "parentId": 101813,
          "unserviceable": false,
          "veg": false,
          "select": false,
          "favorite": false,
          "tradeCampaignHeaders": [
            
          ],
          "aggregatedDiscountInfo": {
            "header": "50% off",
            "shortDescriptionList": [
              {
                "meta": "50% off | Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "aggregatedDiscountInfoV2": {
            "header": "50% OFF",
            "shortDescriptionList": [
              {
                "meta": "Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "chain": [
            
          ],
          "feeDetails": {
            "fees": [
              
            ],
            "totalFees": 0,
            "message": "",
            "title": "",
            "amount": "",
            "icon": ""
          },
          "availability": {
            "opened": true,
            "nextOpenMessage": "",
            "nextCloseMessage": ""
          },
          "longDistanceEnabled": 0,
          "rainMode": "NONE",
          "thirdPartyAddress": false,
          "thirdPartyVendor": "",
          "adTrackingID": "",
          "badges": {
            "imageBased": [
              
            ],
            "textBased": [
              
            ],
            "textExtendedBadges": [
              
            ]
          },
          "lastMileTravelString": "1.2 kms",
          "hasSurge": false,
          "sla": {
            "restaurantId": "257839",
            "deliveryTime": 28,
            "minDeliveryTime": 28,
            "maxDeliveryTime": 28,
            "lastMileTravel": 1.2999999523162842,
            "lastMileDistance": 0,
            "serviceability": "SERVICEABLE",
            "rainMode": "NONE",
            "longDistance": "NOT_LONG_DISTANCE",
            "preferentialService": false,
            "iconType": "EMPTY"
          },
          "promoted": false,
          "avgRating": "3.5",
          "totalRatings": 20,
          "new": false
        },
        "subtype": "basic"
      },
      {
        "type": "restaurant",
        "data": {
          "type": "F",
          "id": "603153",
          "name": "La Pino'z Pizza",
          "uuid": "f453b9b6-caa4-4bd3-a608-e6a467838a4f",
          "city": "5",
          "area": "Kharghar",
          "totalRatingsString": "500+ ratings",
          "cloudinaryImageId": "fiwokq6fg8it4qyvtvi8",
          "cuisines": [
            "Pizzas",
            "Beverages"
          ],
          "tags": [
            
          ],
          "costForTwo": 40000,
          "costForTwoString": "₹400 FOR TWO",
          "deliveryTime": 21,
          "minDeliveryTime": 21,
          "maxDeliveryTime": 21,
          "slaString": "21 MINS",
          "lastMileTravel": 4.400000095367432,
          "slugs": {
            "restaurant": "la-pinoz-pizza-kharghar-kharghar",
            "city": "mumbai"
          },
          "cityState": "5",
          "address": "26 & 27, sai Swar, nearlittle world mall, plot no20, sec 2, kharghar 410210",
          "locality": "Nearlittle World Mall",
          "parentId": 4961,
          "unserviceable": false,
          "veg": true,
          "select": false,
          "favorite": false,
          "tradeCampaignHeaders": [
            
          ],
          "aggregatedDiscountInfo": {
            "header": "50% off",
            "shortDescriptionList": [
              {
                "meta": "50% off | Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "aggregatedDiscountInfoV2": {
            "header": "50% OFF",
            "shortDescriptionList": [
              {
                "meta": "Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "ribbon": [
            {
              "type": "PROMOTED"
            }
          ],
          "chain": [
            
          ],
          "feeDetails": {
            "fees": [
              
            ],
            "totalFees": 0,
            "message": "",
            "title": "",
            "amount": "",
            "icon": ""
          },
          "availability": {
            "opened": true,
            "nextOpenMessage": "",
            "nextCloseMessage": ""
          },
          "longDistanceEnabled": 0,
          "rainMode": "NONE",
          "thirdPartyAddress": false,
          "thirdPartyVendor": "",
          "adTrackingID": "cid=5922783~p=4~eid=00000186-4715-5968-37ea-e98a004e0443",
          "badges": {
            "imageBased": [
              
            ],
            "textBased": [
              
            ],
            "textExtendedBadges": [
              
            ]
          },
          "lastMileTravelString": "4.4 kms",
          "hasSurge": false,
          "sla": {
            "restaurantId": "603153",
            "deliveryTime": 21,
            "minDeliveryTime": 21,
            "maxDeliveryTime": 21,
            "lastMileTravel": 4.400000095367432,
            "lastMileDistance": 0,
            "serviceability": "SERVICEABLE",
            "rainMode": "NONE",
            "longDistance": "NOT_LONG_DISTANCE",
            "preferentialService": false,
            "iconType": "EMPTY"
          },
          "promoted": true,
          "avgRating": "4.3",
          "totalRatings": 500,
          "new": false
        },
        "subtype": "basic"
      },
      {
        "type": "restaurant",
        "data": {
          "type": "F",
          "id": "407269",
          "name": "The Wok Express",
          "uuid": "9d55945d-c9ee-4859-ae24-7ee2366bc98c",
          "city": "5",
          "area": "Kamothe",
          "totalRatingsString": "20+ ratings",
          "cloudinaryImageId": "gclu7flvyd3nxfxx5prk",
          "cuisines": [
            "Chinese",
            "Seafood"
          ],
          "tags": [
            
          ],
          "costForTwo": 20000,
          "costForTwoString": "₹200 FOR TWO",
          "deliveryTime": 26,
          "minDeliveryTime": 26,
          "maxDeliveryTime": 26,
          "slaString": "26 MINS",
          "lastMileTravel": 1.100000023841858,
          "slugs": {
            "restaurant": "the-wok-express-kamothe-kamothe",
            "city": "mumbai"
          },
          "cityState": "5",
          "address": "Shop No. 5, Tharwani Residency, Sec  6A, Kamothe, Beside Hotel Mansarovar",
          "locality": "Sec 6A",
          "parentId": 215404,
          "unserviceable": false,
          "veg": false,
          "select": false,
          "favorite": false,
          "tradeCampaignHeaders": [
            
          ],
          "aggregatedDiscountInfo": {
            "header": "50% off",
            "shortDescriptionList": [
              {
                "meta": "50% off | Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "aggregatedDiscountInfoV2": {
            "header": "50% OFF",
            "shortDescriptionList": [
              {
                "meta": "Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "chain": [
            
          ],
          "feeDetails": {
            "fees": [
              
            ],
            "totalFees": 0,
            "message": "",
            "title": "",
            "amount": "",
            "icon": ""
          },
          "availability": {
            "opened": true,
            "nextOpenMessage": "",
            "nextCloseMessage": ""
          },
          "longDistanceEnabled": 0,
          "rainMode": "NONE",
          "thirdPartyAddress": false,
          "thirdPartyVendor": "",
          "adTrackingID": "",
          "badges": {
            "imageBased": [
              
            ],
            "textBased": [
              
            ],
            "textExtendedBadges": [
              
            ]
          },
          "lastMileTravelString": "1.1 kms",
          "hasSurge": false,
          "sla": {
            "restaurantId": "407269",
            "deliveryTime": 26,
            "minDeliveryTime": 26,
            "maxDeliveryTime": 26,
            "lastMileTravel": 1.100000023841858,
            "lastMileDistance": 0,
            "serviceability": "SERVICEABLE",
            "rainMode": "NONE",
            "longDistance": "NOT_LONG_DISTANCE",
            "preferentialService": false,
            "iconType": "EMPTY"
          },
          "promoted": false,
          "avgRating": "3.7",
          "totalRatings": 20,
          "new": false
        },
        "subtype": "basic"
      },
      {
        "type": "restaurant",
        "data": {
          "type": "F",
          "id": "446547",
          "name": "Shaan-E-Punjab",
          "uuid": "902d89dc-a09c-49b3-93b3-90df2affb96c",
          "city": "5",
          "area": "Kharghar",
          "totalRatingsString": "Too Few Ratings",
          "cloudinaryImageId": "nly3njn7zwmnvlcybbsp",
          "cuisines": [
            "Punjabi",
            "North Indian"
          ],
          "tags": [
            
          ],
          "costForTwo": 25000,
          "costForTwoString": "₹250 FOR TWO",
          "deliveryTime": 27,
          "minDeliveryTime": 27,
          "maxDeliveryTime": 27,
          "slaString": "27 MINS",
          "lastMileTravel": 4.800000190734863,
          "slugs": {
            "restaurant": "true-chinese-indirapuram-indirapuram",
            "city": "mumbai"
          },
          "cityState": "5",
          "address": "SHOP- 1B ,PLOT-184 , SECTOR -13 , CHAIRMAN , KHARGHAR, Panvel (Rural), Raigad, Maharashtra - 410210",
          "locality": "Chairman",
          "parentId": 821,
          "unserviceable": false,
          "veg": false,
          "select": false,
          "favorite": false,
          "tradeCampaignHeaders": [
            
          ],
          "aggregatedDiscountInfo": {
            "header": "50% off",
            "shortDescriptionList": [
              {
                "meta": "50% off | Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "aggregatedDiscountInfoV2": {
            "header": "50% OFF",
            "shortDescriptionList": [
              {
                "meta": "Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "ribbon": [
            {
              "type": "PROMOTED"
            }
          ],
          "chain": [
            
          ],
          "feeDetails": {
            "fees": [
              
            ],
            "totalFees": 0,
            "message": "",
            "title": "",
            "amount": "",
            "icon": ""
          },
          "availability": {
            "opened": true,
            "nextOpenMessage": "",
            "nextCloseMessage": ""
          },
          "longDistanceEnabled": 0,
          "rainMode": "NONE",
          "thirdPartyAddress": false,
          "thirdPartyVendor": "",
          "adTrackingID": "cid=5838871~p=7~eid=00000186-4715-5968-37ea-e98b004e0766",
          "badges": {
            "imageBased": [
              
            ],
            "textBased": [
              
            ],
            "textExtendedBadges": [
              
            ]
          },
          "lastMileTravelString": "4.8 kms",
          "hasSurge": false,
          "sla": {
            "restaurantId": "446547",
            "deliveryTime": 27,
            "minDeliveryTime": 27,
            "maxDeliveryTime": 27,
            "lastMileTravel": 4.800000190734863,
            "lastMileDistance": 0,
            "serviceability": "SERVICEABLE",
            "rainMode": "NONE",
            "longDistance": "NOT_LONG_DISTANCE",
            "preferentialService": false,
            "iconType": "EMPTY"
          },
          "promoted": true,
          "avgRating": "--",
          "totalRatings": 0,
          "new": false
        },
        "subtype": "basic"
      },
      {
        "type": "restaurant",
        "data": {
          "type": "F",
          "id": "160900",
          "name": "The Chinese Bistro",
          "uuid": "d64e7fc3-a356-4577-848c-c78cdcccc494",
          "city": "5",
          "area": "Panvel",
          "totalRatingsString": "50+ ratings",
          "cloudinaryImageId": "r1beluamvsrorbikfwtw",
          "cuisines": [
            "Chinese"
          ],
          "tags": [
            
          ],
          "costForTwo": 30000,
          "costForTwoString": "₹300 FOR TWO",
          "deliveryTime": 24,
          "minDeliveryTime": 24,
          "maxDeliveryTime": 24,
          "slaString": "24 MINS",
          "lastMileTravel": 1.100000023841858,
          "slugs": {
            "restaurant": "the-chinese-bistro-kamothe",
            "city": "mumbai"
          },
          "cityState": "5",
          "address": "SHOP NO 01 , NAYAN APRTMENT , PLOT NO  57 / 2, SECTOR 6 A ,KAMOTHE, Panvel City,  Raigad, Maharashtra-410209",
          "locality": "Kamothe",
          "parentId": 206827,
          "unserviceable": false,
          "veg": false,
          "select": false,
          "favorite": false,
          "tradeCampaignHeaders": [
            
          ],
          "aggregatedDiscountInfo": {
            "header": "40% off",
            "shortDescriptionList": [
              {
                "meta": "40% off | Use GUILTFREE",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "40% off up to ₹100 | Use code GUILTFREE",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "aggregatedDiscountInfoV2": {
            "header": "40% OFF",
            "shortDescriptionList": [
              {
                "meta": "Use GUILTFREE",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "40% off up to ₹100 | Use code GUILTFREE",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "chain": [
            
          ],
          "feeDetails": {
            "fees": [
              
            ],
            "totalFees": 0,
            "message": "",
            "title": "",
            "amount": "",
            "icon": ""
          },
          "availability": {
            "opened": true,
            "nextOpenMessage": "",
            "nextCloseMessage": ""
          },
          "longDistanceEnabled": 0,
          "rainMode": "NONE",
          "thirdPartyAddress": false,
          "thirdPartyVendor": "",
          "adTrackingID": "",
          "badges": {
            "imageBased": [
              
            ],
            "textBased": [
              
            ],
            "textExtendedBadges": [
              
            ]
          },
          "lastMileTravelString": "1.1 kms",
          "hasSurge": false,
          "sla": {
            "restaurantId": "160900",
            "deliveryTime": 24,
            "minDeliveryTime": 24,
            "maxDeliveryTime": 24,
            "lastMileTravel": 1.100000023841858,
            "lastMileDistance": 0,
            "serviceability": "SERVICEABLE",
            "rainMode": "NONE",
            "longDistance": "NOT_LONG_DISTANCE",
            "preferentialService": false,
            "iconType": "EMPTY"
          },
          "promoted": false,
          "avgRating": "3.6",
          "totalRatings": 50,
          "new": false
        },
        "subtype": "basic"
      },
      {
        "type": "restaurant",
        "data": {
          "type": "F",
          "id": "390098",
          "name": "NH1 Bowls - Highway To North",
          "uuid": "072caf60-4ca9-40fb-9082-ccc37d96750a",
          "city": "5",
          "area": "Kamothe",
          "totalRatingsString": "20+ ratings",
          "cloudinaryImageId": "s5bgtewhaakq4rr6s4b7",
          "cuisines": [
            "North Indian",
            "Punjabi",
            "Home Food"
          ],
          "tags": [
            
          ],
          "costForTwo": 25000,
          "costForTwoString": "₹250 FOR TWO",
          "deliveryTime": 33,
          "minDeliveryTime": 33,
          "maxDeliveryTime": 33,
          "slaString": "33 MINS",
          "lastMileTravel": 1.2000000476837158,
          "slugs": {
            "restaurant": "nh1-bowls-highway-to-north-kasarvadavali-thane-hiranandani-estate",
            "city": "mumbai"
          },
          "cityState": "5",
          "address": "Shop 1, Ambe Shraddha, Sector 36 Kamothe, Navi Mumbai",
          "locality": "Sector-36",
          "parentId": 22452,
          "unserviceable": false,
          "veg": false,
          "select": false,
          "favorite": false,
          "tradeCampaignHeaders": [
            
          ],
          "aggregatedDiscountInfo": {
            "header": "50% off",
            "shortDescriptionList": [
              {
                "meta": "50% off | Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "aggregatedDiscountInfoV2": {
            "header": "50% OFF",
            "shortDescriptionList": [
              {
                "meta": "Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "chain": [
            
          ],
          "feeDetails": {
            "fees": [
              
            ],
            "totalFees": 0,
            "message": "",
            "title": "",
            "amount": "",
            "icon": ""
          },
          "availability": {
            "opened": true,
            "nextOpenMessage": "",
            "nextCloseMessage": ""
          },
          "longDistanceEnabled": 0,
          "rainMode": "NONE",
          "thirdPartyAddress": false,
          "thirdPartyVendor": "",
          "adTrackingID": "",
          "badges": {
            "imageBased": [
              
            ],
            "textBased": [
              
            ],
            "textExtendedBadges": [
              
            ]
          },
          "lastMileTravelString": "1.2 kms",
          "hasSurge": false,
          "sla": {
            "restaurantId": "390098",
            "deliveryTime": 33,
            "minDeliveryTime": 33,
            "maxDeliveryTime": 33,
            "lastMileTravel": 1.2000000476837158,
            "lastMileDistance": 0,
            "serviceability": "SERVICEABLE",
            "rainMode": "NONE",
            "longDistance": "NOT_LONG_DISTANCE",
            "preferentialService": false,
            "iconType": "EMPTY"
          },
          "promoted": false,
          "avgRating": "3.8",
          "totalRatings": 20,
          "new": false
        },
        "subtype": "basic"
      },
      {
        "type": "restaurant",
        "data": {
          "type": "F",
          "id": "533916",
          "name": "NEW AJWA FAMILY RESTAURANT",
          "uuid": "0eb48d58-890d-4dde-a8c5-4efae42cdcf4",
          "city": "5",
          "area": "Kharghar",
          "totalRatingsString": "50+ ratings",
          "cloudinaryImageId": "yhei8pqud0uvrns5in1w",
          "cuisines": [
            "Mughlai",
            "Fast Food"
          ],
          "tags": [
            
          ],
          "costForTwo": 50000,
          "costForTwoString": "₹500 FOR TWO",
          "deliveryTime": 27,
          "minDeliveryTime": 27,
          "maxDeliveryTime": 27,
          "slaString": "27 MINS",
          "lastMileTravel": 4.599999904632568,
          "slugs": {
            "restaurant": "new-ajwa-family-restaurant-kharghar-kharghar",
            "city": "mumbai"
          },
          "cityState": "5",
          "address": "SHOP NO 59/60 GROUND FLOOR PATEL HARITAGE PLOT NO 15/17SECTOR-7 KHARGHAR NAVI MUMBAI 410210",
          "locality": "Sector7",
          "parentId": 145704,
          "unserviceable": false,
          "veg": false,
          "select": false,
          "favorite": false,
          "tradeCampaignHeaders": [
            
          ],
          "aggregatedDiscountInfo": {
            "header": "50% off",
            "shortDescriptionList": [
              {
                "meta": "50% off | Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "aggregatedDiscountInfoV2": {
            "header": "50% OFF",
            "shortDescriptionList": [
              {
                "meta": "Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "ribbon": [
            {
              "type": "PROMOTED"
            }
          ],
          "chain": [
            
          ],
          "feeDetails": {
            "fees": [
              
            ],
            "totalFees": 0,
            "message": "",
            "title": "",
            "amount": "",
            "icon": ""
          },
          "availability": {
            "opened": true,
            "nextOpenMessage": "",
            "nextCloseMessage": "Closes soon"
          },
          "longDistanceEnabled": 0,
          "rainMode": "NONE",
          "thirdPartyAddress": false,
          "thirdPartyVendor": "",
          "adTrackingID": "cid=5838929~p=10~eid=00000186-4715-5968-37ea-e98c004e0a62",
          "badges": {
            "imageBased": [
              
            ],
            "textBased": [
              
            ],
            "textExtendedBadges": [
              
            ]
          },
          "lastMileTravelString": "4.5 kms",
          "hasSurge": false,
          "sla": {
            "restaurantId": "533916",
            "deliveryTime": 27,
            "minDeliveryTime": 27,
            "maxDeliveryTime": 27,
            "lastMileTravel": 4.599999904632568,
            "lastMileDistance": 0,
            "serviceability": "SERVICEABLE",
            "rainMode": "NONE",
            "longDistance": "NOT_LONG_DISTANCE",
            "preferentialService": false,
            "iconType": "EMPTY"
          },
          "promoted": true,
          "avgRating": "3.9",
          "totalRatings": 50,
          "new": false
        },
        "subtype": "basic"
      },
      {
        "type": "restaurant",
        "data": {
          "type": "F",
          "id": "462437",
          "name": "Hotel Sai Raj",
          "uuid": "eeb43411-907d-4293-9a62-6de5b1fa4459",
          "city": "5",
          "area": "Kamothe",
          "totalRatingsString": "Too Few Ratings",
          "cloudinaryImageId": "q7wdvohvwe0818wjki3v",
          "cuisines": [
            "South Indian",
            "Snacks"
          ],
          "tags": [
            
          ],
          "costForTwo": 25000,
          "costForTwoString": "₹250 FOR TWO",
          "deliveryTime": 30,
          "minDeliveryTime": 30,
          "maxDeliveryTime": 30,
          "slaString": "30 MINS",
          "lastMileTravel": 1.2999999523162842,
          "slugs": {
            "restaurant": "hotel-sai-raj-kamothe-kamothe",
            "city": "mumbai"
          },
          "cityState": "5",
          "address": "Shop No.7, Channel Nest Building, Plot No. 13, Shalome CHS, Sector 7, Kamothe, Panvel, Navi Mumbai, Maharashtra 410209, India",
          "locality": "Shalome Chs",
          "parentId": 101820,
          "unserviceable": false,
          "veg": false,
          "select": false,
          "favorite": false,
          "tradeCampaignHeaders": [
            
          ],
          "aggregatedDiscountInfo": {
            "header": "50% off",
            "shortDescriptionList": [
              {
                "meta": "50% off | Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "aggregatedDiscountInfoV2": {
            "header": "50% OFF",
            "shortDescriptionList": [
              {
                "meta": "Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "chain": [
            
          ],
          "feeDetails": {
            "fees": [
              
            ],
            "totalFees": 0,
            "message": "",
            "title": "",
            "amount": "",
            "icon": ""
          },
          "availability": {
            "opened": true,
            "nextOpenMessage": "",
            "nextCloseMessage": ""
          },
          "longDistanceEnabled": 0,
          "rainMode": "NONE",
          "thirdPartyAddress": false,
          "thirdPartyVendor": "",
          "adTrackingID": "",
          "badges": {
            "imageBased": [
              
            ],
            "textBased": [
              
            ],
            "textExtendedBadges": [
              
            ]
          },
          "lastMileTravelString": "1.2 kms",
          "hasSurge": false,
          "sla": {
            "restaurantId": "462437",
            "deliveryTime": 30,
            "minDeliveryTime": 30,
            "maxDeliveryTime": 30,
            "lastMileTravel": 1.2999999523162842,
            "lastMileDistance": 0,
            "serviceability": "SERVICEABLE",
            "rainMode": "NONE",
            "longDistance": "NOT_LONG_DISTANCE",
            "preferentialService": false,
            "iconType": "EMPTY"
          },
          "promoted": false,
          "avgRating": "--",
          "totalRatings": 0,
          "new": false
        },
        "subtype": "basic"
      },
      {
        "type": "restaurant",
        "data": {
          "type": "F",
          "id": "274861",
          "name": "Mealful Rolls - India's Biggest Rolls",
          "uuid": "b252ced9-cd55-47ff-8a02-8b56faa75848",
          "city": "5",
          "area": "Kamothe",
          "totalRatingsString": "20+ ratings",
          "cloudinaryImageId": "vyf6rsnr37kpkkzj3cl1",
          "cuisines": [
            "Fast Food",
            "Snacks",
            "North Indian",
            "Desserts"
          ],
          "tags": [
            
          ],
          "costForTwo": 25000,
          "costForTwoString": "₹250 FOR TWO",
          "deliveryTime": 30,
          "minDeliveryTime": 30,
          "maxDeliveryTime": 30,
          "slaString": "30 MINS",
          "lastMileTravel": 1.2000000476837158,
          "slugs": {
            "restaurant": "mealful-wraps-meals-in-a-wrap-kamothe-kamothe",
            "city": "mumbai"
          },
          "cityState": "5",
          "address": "Shop 1, Ambe Shraddha, Sector 36 Kamothe, Navi Mumbai",
          "locality": "Sector-36",
          "parentId": 10390,
          "unserviceable": false,
          "veg": false,
          "select": false,
          "favorite": false,
          "tradeCampaignHeaders": [
            
          ],
          "aggregatedDiscountInfo": {
            "header": "50% off",
            "shortDescriptionList": [
              {
                "meta": "50% off | Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "aggregatedDiscountInfoV2": {
            "header": "50% OFF",
            "shortDescriptionList": [
              {
                "meta": "Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "chain": [
            
          ],
          "feeDetails": {
            "fees": [
              
            ],
            "totalFees": 0,
            "message": "",
            "title": "",
            "amount": "",
            "icon": ""
          },
          "availability": {
            "opened": true,
            "nextOpenMessage": "",
            "nextCloseMessage": ""
          },
          "longDistanceEnabled": 0,
          "rainMode": "NONE",
          "thirdPartyAddress": false,
          "thirdPartyVendor": "",
          "adTrackingID": "",
          "badges": {
            "imageBased": [
              
            ],
            "textBased": [
              
            ],
            "textExtendedBadges": [
              
            ]
          },
          "lastMileTravelString": "1.2 kms",
          "hasSurge": false,
          "sla": {
            "restaurantId": "274861",
            "deliveryTime": 30,
            "minDeliveryTime": 30,
            "maxDeliveryTime": 30,
            "lastMileTravel": 1.2000000476837158,
            "lastMileDistance": 0,
            "serviceability": "SERVICEABLE",
            "rainMode": "NONE",
            "longDistance": "NOT_LONG_DISTANCE",
            "preferentialService": false,
            "iconType": "EMPTY"
          },
          "promoted": false,
          "avgRating": "4.0",
          "totalRatings": 20,
          "new": false
        },
        "subtype": "basic"
      },
      {
        "type": "restaurant",
        "data": {
          "type": "F",
          "id": "27116",
          "name": "Behrouz Biryani",
          "uuid": "61691c5b-2792-4fcd-afd9-0da2210988fb",
          "city": "5",
          "area": "Kharghar RK",
          "totalRatingsString": "100+ ratings",
          "cloudinaryImageId": "fldql8zklowbri3v11ja",
          "cuisines": [
            "Biryani",
            "Mughlai",
            "Lucknowi",
            "Hyderabadi",
            "Kebabs",
            "North Indian",
            "Persian",
            "Desserts"
          ],
          "tags": [
            
          ],
          "costForTwo": 50000,
          "costForTwoString": "₹500 FOR TWO",
          "deliveryTime": 28,
          "minDeliveryTime": 28,
          "maxDeliveryTime": 28,
          "slaString": "28 MINS",
          "lastMileTravel": 4.900000095367432,
          "slugs": {
            "restaurant": "behrouz-biryani-twins-tower-kharghar",
            "city": "mumbai"
          },
          "cityState": "5",
          "address": "Simran Residency, Shop No 26 to 28, Sector 7, Kharghar, Navi Mumbai, Maharashtra 410210",
          "locality": "Simran Residency",
          "parentId": 1803,
          "unserviceable": false,
          "veg": false,
          "select": false,
          "favorite": false,
          "tradeCampaignHeaders": [
            
          ],
          "aggregatedDiscountInfo": {
            "header": "50% off",
            "shortDescriptionList": [
              {
                "meta": "50% off | Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "aggregatedDiscountInfoV2": {
            "header": "50% OFF",
            "shortDescriptionList": [
              {
                "meta": "Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "ribbon": [
            {
              "type": "PROMOTED"
            }
          ],
          "chain": [
            
          ],
          "feeDetails": {
            "fees": [
              
            ],
            "totalFees": 0,
            "message": "",
            "title": "",
            "amount": "",
            "icon": ""
          },
          "availability": {
            "opened": true,
            "nextOpenMessage": "",
            "nextCloseMessage": ""
          },
          "longDistanceEnabled": 0,
          "rainMode": "NONE",
          "thirdPartyAddress": false,
          "thirdPartyVendor": "",
          "adTrackingID": "cid=5936431~p=13~eid=00000186-4715-5968-37ea-e98d004e0d39",
          "badges": {
            "imageBased": [
              
            ],
            "textBased": [
              
            ],
            "textExtendedBadges": [
              
            ]
          },
          "lastMileTravelString": "4.9 kms",
          "hasSurge": false,
          "sla": {
            "restaurantId": "27116",
            "deliveryTime": 28,
            "minDeliveryTime": 28,
            "maxDeliveryTime": 28,
            "lastMileTravel": 4.900000095367432,
            "lastMileDistance": 0,
            "serviceability": "SERVICEABLE",
            "rainMode": "NONE",
            "longDistance": "NOT_LONG_DISTANCE",
            "preferentialService": false,
            "iconType": "EMPTY"
          },
          "promoted": true,
          "avgRating": "4.3",
          "totalRatings": 100,
          "new": false
        },
        "subtype": "basic"
      },
      {
        "type": "restaurant",
        "data": {
          "type": "F",
          "id": "289311",
          "name": "BOX8 - Desi Meals",
          "uuid": "3815c946-9cd9-4cd3-bfe4-6208e2e859e0",
          "city": "5",
          "area": "Panvel",
          "totalRatingsString": "100+ ratings",
          "cloudinaryImageId": "usvcmhgqyuyhg5tah1vn",
          "cuisines": [
            "North Indian",
            "Biryani",
            "Thalis",
            "Home Food"
          ],
          "tags": [
            
          ],
          "costForTwo": 25000,
          "costForTwoString": "₹250 FOR TWO",
          "deliveryTime": 25,
          "minDeliveryTime": 25,
          "maxDeliveryTime": 25,
          "slaString": "25 MINS",
          "lastMileTravel": 1.2000000476837158,
          "slugs": {
            "restaurant": "box8-desi-meals-kamothe-kamothe",
            "city": "mumbai"
          },
          "cityState": "5",
          "address": "Shop 1, Ambe Shraddha, Sector 36 Kamothe, Navi Mumbai",
          "locality": "Kamothe",
          "parentId": 10655,
          "unserviceable": false,
          "veg": false,
          "select": false,
          "favorite": false,
          "tradeCampaignHeaders": [
            
          ],
          "aggregatedDiscountInfo": {
            "header": "50% off",
            "shortDescriptionList": [
              {
                "meta": "50% off | Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "aggregatedDiscountInfoV2": {
            "header": "50% OFF",
            "shortDescriptionList": [
              {
                "meta": "Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "chain": [
            
          ],
          "feeDetails": {
            "fees": [
              
            ],
            "totalFees": 0,
            "message": "",
            "title": "",
            "amount": "",
            "icon": ""
          },
          "availability": {
            "opened": true,
            "nextOpenMessage": "",
            "nextCloseMessage": ""
          },
          "longDistanceEnabled": 0,
          "rainMode": "NONE",
          "thirdPartyAddress": false,
          "thirdPartyVendor": "",
          "adTrackingID": "",
          "badges": {
            "imageBased": [
              
            ],
            "textBased": [
              
            ],
            "textExtendedBadges": [
              
            ]
          },
          "lastMileTravelString": "1.2 kms",
          "hasSurge": false,
          "sla": {
            "restaurantId": "289311",
            "deliveryTime": 25,
            "minDeliveryTime": 25,
            "maxDeliveryTime": 25,
            "lastMileTravel": 1.2000000476837158,
            "lastMileDistance": 0,
            "serviceability": "SERVICEABLE",
            "rainMode": "NONE",
            "longDistance": "NOT_LONG_DISTANCE",
            "preferentialService": false,
            "iconType": "EMPTY"
          },
          "promoted": false,
          "avgRating": "4.0",
          "totalRatings": 100,
          "new": false
        },
        "subtype": "basic"
      },
      {
        "type": "restaurant",
        "data": {
          "type": "F",
          "id": "391042",
          "name": "ZAZA 22 Spice Biryani",
          "uuid": "334d0334-0512-49b4-84f6-2feb39fddfc7",
          "city": "5",
          "area": "Kamothe",
          "totalRatingsString": "20+ ratings",
          "cloudinaryImageId": "y8zqnflyfgeduazidz3b",
          "cuisines": [
            "Biryani",
            "North Indian",
            "Awadhi"
          ],
          "tags": [
            
          ],
          "costForTwo": 25000,
          "costForTwoString": "₹250 FOR TWO",
          "deliveryTime": 27,
          "minDeliveryTime": 27,
          "maxDeliveryTime": 27,
          "slaString": "27 MINS",
          "lastMileTravel": 1.2000000476837158,
          "slugs": {
            "restaurant": "zaza-21-spice-biryani-kamothe-kamothe",
            "city": "mumbai"
          },
          "cityState": "5",
          "address": "Shop 1, Ambe Shraddha, Sector 36 Kamothe, Navi Mumbai",
          "locality": "Sector-36",
          "parentId": 22473,
          "unserviceable": false,
          "veg": false,
          "select": false,
          "favorite": false,
          "tradeCampaignHeaders": [
            
          ],
          "aggregatedDiscountInfo": {
            "header": "50% off",
            "shortDescriptionList": [
              {
                "meta": "50% off | Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "aggregatedDiscountInfoV2": {
            "header": "50% OFF",
            "shortDescriptionList": [
              {
                "meta": "Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "chain": [
            
          ],
          "feeDetails": {
            "fees": [
              
            ],
            "totalFees": 0,
            "message": "",
            "title": "",
            "amount": "",
            "icon": ""
          },
          "availability": {
            "opened": true,
            "nextOpenMessage": "",
            "nextCloseMessage": ""
          },
          "longDistanceEnabled": 0,
          "rainMode": "NONE",
          "thirdPartyAddress": false,
          "thirdPartyVendor": "",
          "adTrackingID": "",
          "badges": {
            "imageBased": [
              
            ],
            "textBased": [
              
            ],
            "textExtendedBadges": [
              
            ]
          },
          "lastMileTravelString": "1.2 kms",
          "hasSurge": false,
          "sla": {
            "restaurantId": "391042",
            "deliveryTime": 27,
            "minDeliveryTime": 27,
            "maxDeliveryTime": 27,
            "lastMileTravel": 1.2000000476837158,
            "lastMileDistance": 0,
            "serviceability": "SERVICEABLE",
            "rainMode": "NONE",
            "longDistance": "NOT_LONG_DISTANCE",
            "preferentialService": false,
            "iconType": "EMPTY"
          },
          "promoted": false,
          "avgRating": "3.3",
          "totalRatings": 20,
          "new": false
        },
        "subtype": "basic"
      },
      {
        "type": "restaurant",
        "data": {
          "type": "F",
          "id": "555785",
          "name": "Gobblers Rolls & Bowls",
          "uuid": "848cf56e-abee-456b-bfc5-113ba2d74cff",
          "city": "5",
          "area": "Kharghar",
          "totalRatingsString": "50+ ratings",
          "cloudinaryImageId": "ktnpf2f2lfstppq4qjhz",
          "cuisines": [
            "Arabian",
            "Italian",
            "North Indian",
            "Chinese",
            "Fast Food",
            "Snacks",
            "American"
          ],
          "tags": [
            
          ],
          "costForTwo": 30000,
          "costForTwoString": "₹300 FOR TWO",
          "deliveryTime": 29,
          "minDeliveryTime": 29,
          "maxDeliveryTime": 29,
          "slaString": "29 MINS",
          "lastMileTravel": 5,
          "slugs": {
            "restaurant": "gobblers-rolls-&-bowls-kharghar-kharghar",
            "city": "mumbai"
          },
          "cityState": "5",
          "address": "14, Aum Sai Chs., Plot no. - 23C, Sec. - 7, Kharghar, Panvel (Rural), Raigad, Maharashtra - 410210",
          "locality": "Aum Sai Chs",
          "parentId": 264245,
          "unserviceable": false,
          "veg": false,
          "select": false,
          "favorite": false,
          "tradeCampaignHeaders": [
            
          ],
          "aggregatedDiscountInfo": {
            "header": "50% off",
            "shortDescriptionList": [
              {
                "meta": "50% off | Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "aggregatedDiscountInfoV2": {
            "header": "50% OFF",
            "shortDescriptionList": [
              {
                "meta": "Use WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "descriptionList": [
              {
                "meta": "50% off up to ₹100 | Use code WELCOME50",
                "discountType": "Percentage",
                "operationType": "RESTAURANT"
              }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
          },
          "ribbon": [
            {
              "type": "PROMOTED"
            }
          ],
          "chain": [
            
          ],
          "feeDetails": {
            "fees": [
              
            ],
            "totalFees": 0,
            "message": "",
            "title": "",
            "amount": "",
            "icon": ""
          },
          "availability": {
            "opened": true,
            "nextOpenMessage": "",
            "nextCloseMessage": ""
          },
          "longDistanceEnabled": 0,
          "rainMode": "NONE",
          "thirdPartyAddress": false,
          "thirdPartyVendor": "",
          "adTrackingID": "cid=5909494~p=16~eid=00000186-4715-5968-37ea-e98e004e1009",
          "badges": {
            "imageBased": [
              
            ],
            "textBased": [
              
            ],
            "textExtendedBadges": [
              
            ]
          },
          "lastMileTravelString": "5 kms",
          "hasSurge": false,
          "sla": {
            "restaurantId": "555785",
            "deliveryTime": 29,
            "minDeliveryTime": 29,
            "maxDeliveryTime": 29,
            "lastMileTravel": 5,
            "lastMileDistance": 0,
            "serviceability": "SERVICEABLE",
            "rainMode": "NONE",
            "longDistance": "NOT_LONG_DISTANCE",
            "preferentialService": false,
            "iconType": "EMPTY"
          },
          "promoted": true,
          "avgRating": "3.9",
          "totalRatings": 50,
          "new": false
        },
        "subtype": "basic"
  },
  {
    "type": "restaurant",
    "data": {
        "type": "F",
        "id": "550373",
        "name": "Thali meals paratha",
        "uuid": "f09f1867-eee7-41f4-978c-6300f1063e81",
        "city": "5",
        "area": "Panvel",
        "totalRatingsString": "Too Few Ratings",
        "cloudinaryImageId": "hlee27tc9icwg6l259eh",
        "cuisines": [
            "Thalis",
            "Indian"
        ],
        "tags": [
        
        ],
        "costForTwo": 25000,
        "costForTwoString": "₹250 FOR TWO",
        "deliveryTime": 38,
        "minDeliveryTime": 38,
        "maxDeliveryTime": 38,
        "slaString": "38 MINS",
        "lastMileTravel": 4.400000095367432,
        "slugs": {
            "restaurant": "thali-meals-paratha-andheri-west-andheri-west",
            "city": "mumbai"
        },
        "cityState": "5",
        "address": "SHOP NO. 3/4 AMEY CHS LTD. NEAR CHOURANG HIGHT SECTOR 13 KHARGHAR ,,Panvel (Rural),Raigad,Maharashtra-410210",
        "locality": "SECTOR 13 KHARGHAR",
        "parentId": 330781,
        "unserviceable": false,
        "veg": false,
        "select": false,
        "favorite": false,
        "tradeCampaignHeaders": [
        
        ],
        "aggregatedDiscountInfo": {
            "header": "50% off",
            "shortDescriptionList": [
                {
                    "meta": "50% off | Use WELCOME50",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                }
            ],
            "descriptionList": [
                {
                    "meta": "50% off up to ₹100 | Use code WELCOME50",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
        },
        "aggregatedDiscountInfoV2": {
            "header": "50% OFF",
            "shortDescriptionList": [
                {
                    "meta": "Use WELCOME50",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                }
            ],
            "descriptionList": [
                {
                    "meta": "50% off up to ₹100 | Use code WELCOME50",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                }
            ],
            "subHeader": "",
            "headerType": 0,
            "superFreedel": ""
        },
        "chain": [
        
        ],
        "feeDetails": {
            "fees": [
          
            ],
            "totalFees": 0,
            "message": "",
            "title": "",
            "amount": "",
            "icon": ""
        },
        "availability": {
            "opened": true,
            "nextOpenMessage": "",
            "nextCloseMessage": ""
        },
        "longDistanceEnabled": 0,
        "rainMode": "NONE",
        "thirdPartyAddress": false,
        "thirdPartyVendor": "",
        "adTrackingID": "",
        "badges": {
            "imageBased": [
          
            ],
            "textBased": [
          
            ],
            "textExtendedBadges": [
          
            ]
        },
        "lastMileTravelString": "4.4 kms",
        "hasSurge": false,
        "sla": {
            "restaurantId": "550373",
            "deliveryTime": 38,
            "minDeliveryTime": 38,
            "maxDeliveryTime": 38,
            "lastMileTravel": 4.400000095367432,
            "lastMileDistance": 0,
            "serviceability": "SERVICEABLE",
            "rainMode": "NONE",
            "longDistance": "NOT_LONG_DISTANCE",
            "preferentialService": false,
            "iconType": "EMPTY"
        },
        "promoted": false,
        "avgRating": "--",
        "totalRatings": 0,
        "new": false
    },
    "subtype": "basic"
},
{
        "type": "restaurant",
        "data": {
            "type": "F",
            "id": "370388",
            "name": "P'p Paratha",
            "uuid": "aab8a267-38bc-401a-976c-993d9df84a33",
            "city": "5",
            "area": "Kharghar",
            "totalRatingsString": "20+ ratings",
            "cloudinaryImageId": "knpfvmczzpujlrqsmwvq",
            "cuisines": [
                "Indian",
                "North Indian",
                "Juices",
                "Desserts"
            ],
            "tags": [
        
            ],
            "costForTwo": 20000,
            "costForTwoString": "₹200 FOR TWO",
            "deliveryTime": 30,
            "minDeliveryTime": 30,
            "maxDeliveryTime": 30,
            "slaString": "30 MINS",
            "lastMileTravel": 4.5,
            "slugs": {
                "restaurant": "p'p-paratha-kharghar-kharghar",
                "city": "mumbai"
            },
            "cityState": "5",
            "address": "shop no. 07 Dhanashree CHS, plot no 146 infront of kamdhenu, Sector 13, Kharghar, Navi Mumbai, Maharashtra 410210, India",
            "locality": "Sector 13",
            "parentId": 160219,
            "unserviceable": false,
            "veg": true,
            "select": false,
            "favorite": false,
            "tradeCampaignHeaders": [
        
            ],
            "aggregatedDiscountInfo": {
                "header": "50% off",
                "shortDescriptionList": [
                    {
                        "meta": "50% off | Use WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "descriptionList": [
                    {
                        "meta": "50% off up to ₹100 | Use code WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "subHeader": "",
                "headerType": 0,
                "superFreedel": ""
            },
            "aggregatedDiscountInfoV2": {
                "header": "50% OFF",
                "shortDescriptionList": [
                    {
                        "meta": "Use WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "descriptionList": [
                    {
                        "meta": "50% off up to ₹100 | Use code WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "subHeader": "",
                "headerType": 0,
                "superFreedel": ""
            },
            "chain": [
        
            ],
            "feeDetails": {
                "fees": [
          
                ],
                "totalFees": 0,
                "message": "",
                "title": "",
                "amount": "",
                "icon": ""
            },
            "availability": {
                "opened": true,
                "nextOpenMessage": "",
                "nextCloseMessage": ""
            },
            "longDistanceEnabled": 0,
            "rainMode": "NONE",
            "thirdPartyAddress": false,
            "thirdPartyVendor": "",
            "adTrackingID": "",
            "badges": {
                "imageBased": [
          
                ],
                "textBased": [
          
                ],
                "textExtendedBadges": [
          
                ]
            },
            "lastMileTravelString": "4.5 kms",
            "hasSurge": false,
            "sla": {
                "restaurantId": "370388",
                "deliveryTime": 30,
                "minDeliveryTime": 30,
                "maxDeliveryTime": 30,
                "lastMileTravel": 4.5,
                "lastMileDistance": 0,
                "serviceability": "SERVICEABLE",
                "rainMode": "NONE",
                "longDistance": "NOT_LONG_DISTANCE",
                "preferentialService": false,
                "iconType": "EMPTY"
            },
            "promoted": false,
            "avgRating": "1.5",
            "totalRatings": 20,
            "new": false
        },
        "subtype": "basic"
},
{
    
        "type": "restaurant",
        "data": {
            "type": "F",
            "id": "524723",
            "name": "La Milano Pizzeria",
            "uuid": "1cc57557-5a5d-4f5e-ab4a-7d4f7e8ea12f",
            "city": "5",
            "area": "Kharghar",
            "totalRatingsString": "100+ ratings",
            "cloudinaryImageId": "pkrvhcpzddazwruxhjol",
            "cuisines": [
                "Pizzas",
                "Pastas",
                "Desserts"
            ],
            "tags": [
        
            ],
            "costForTwo": 39900,
            "costForTwoString": "₹399 FOR TWO",
            "deliveryTime": 28,
            "minDeliveryTime": 28,
            "maxDeliveryTime": 28,
            "slaString": "28 MINS",
            "lastMileTravel": 4.599999904632568,
            "slugs": {
                "restaurant": "la-milano-pizzeria-kharghar-kharghar",
                "city": "mumbai"
            },
            "cityState": "5",
            "address": "Shop No. 8 Ground Floor, Crystal Plaza Premises CHS, Plot no. 18 and 27, Sector 7, Kharghar, Navi Mumbai 410210",
            "locality": "Crystal Plaza Premises Chs",
            "parentId": 22533,
            "unserviceable": false,
            "veg": false,
            "select": false,
            "favorite": false,
            "tradeCampaignHeaders": [
        
            ],
            "aggregatedDiscountInfo": {
                "header": "50% off",
                "shortDescriptionList": [
                    {
                        "meta": "50% off | Use WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "descriptionList": [
                    {
                        "meta": "50% off up to ₹100 | Use code WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "subHeader": "",
                "headerType": 0,
                "superFreedel": ""
            },
            "aggregatedDiscountInfoV2": {
                "header": "50% OFF",
                "shortDescriptionList": [
                    {
                        "meta": "Use WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "descriptionList": [
                    {
                        "meta": "50% off up to ₹100 | Use code WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "subHeader": "",
                "headerType": 0,
                "superFreedel": ""
            },
            "chain": [
        
            ],
            "feeDetails": {
                "fees": [
          
                ],
                "totalFees": 0,
                "message": "",
                "title": "",
                "amount": "",
                "icon": ""
            },
            "availability": {
                "opened": true,
                "nextOpenMessage": "",
                "nextCloseMessage": ""
            },
            "longDistanceEnabled": 0,
            "rainMode": "NONE",
            "thirdPartyAddress": false,
            "thirdPartyVendor": "",
            "adTrackingID": "",
            "badges": {
                "imageBased": [
          
                ],
                "textBased": [
          
                ],
                "textExtendedBadges": [
          
                ]
            },
            "lastMileTravelString": "4.5 kms",
            "hasSurge": false,
            "sla": {
                "restaurantId": "524723",
                "deliveryTime": 28,
                "minDeliveryTime": 28,
                "maxDeliveryTime": 28,
                "lastMileTravel": 4.599999904632568,
                "lastMileDistance": 0,
                "serviceability": "SERVICEABLE",
                "rainMode": "NONE",
                "longDistance": "NOT_LONG_DISTANCE",
                "preferentialService": false,
                "iconType": "EMPTY"
            },
            "promoted": false,
            "avgRating": "4.2",
            "totalRatings": 100,
            "new": false
        },
        "subtype": "basic"
},
{
        "type": "restaurant",
        "data": {
            "type": "F",
            "id": "465641",
            "name": "The Tent House Restaurant",
            "uuid": "c232c0d4-d093-433d-b620-da532601c690",
            "city": "5",
            "area": "Bhoomi Tower",
            "totalRatingsString": "50+ ratings",
            "cloudinaryImageId": "wxmgg3jhayx7kyxwzjsv",
            "cuisines": [
                "North Indian",
                "Chinese",
                "Biryani"
            ],
            "tags": [
        
            ],
            "costForTwo": 20000,
            "costForTwoString": "₹200 FOR TWO",
            "deliveryTime": 29,
            "minDeliveryTime": 29,
            "maxDeliveryTime": 29,
            "slaString": "29 MINS",
            "lastMileTravel": 4.599999904632568,
            "slugs": {
                "restaurant": "the-tent-house-restaurant-kharghar-kharghar",
                "city": "mumbai"
            },
            "cityState": "5",
            "address": "SHOP NO. 21, PLOT NO. 28, GROUND FLOOR,, BHOOMI TOWER, SECTOR 4,KHARGHAR,PANVEL (RURAL),RAIGAD,MAHARASHTRA-410210",
            "locality": "Kharghar",
            "parentId": 279637,
            "unserviceable": false,
            "veg": false,
            "select": false,
            "favorite": false,
            "tradeCampaignHeaders": [
        
            ],
            "aggregatedDiscountInfo": {
                "header": "50% off",
                "shortDescriptionList": [
                    {
                        "meta": "50% off | Use WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "descriptionList": [
                    {
                        "meta": "50% off up to ₹100 | Use code WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "subHeader": "",
                "headerType": 0,
                "superFreedel": ""
            },
            "aggregatedDiscountInfoV2": {
                "header": "50% OFF",
                "shortDescriptionList": [
                    {
                        "meta": "Use WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "descriptionList": [
                    {
                        "meta": "50% off up to ₹100 | Use code WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "subHeader": "",
                "headerType": 0,
                "superFreedel": ""
            },
            "chain": [
        
            ],
            "feeDetails": {
                "fees": [
          
                ],
                "totalFees": 0,
                "message": "",
                "title": "",
                "amount": "",
                "icon": ""
            },
            "availability": {
                "opened": true,
                "nextOpenMessage": "",
                "nextCloseMessage": ""
            },
            "longDistanceEnabled": 0,
            "rainMode": "NONE",
            "thirdPartyAddress": false,
            "thirdPartyVendor": "",
            "adTrackingID": "",
            "badges": {
                "imageBased": [
          
                ],
                "textBased": [
          
                ],
                "textExtendedBadges": [
          
                ]
            },
            "lastMileTravelString": "4.5 kms",
            "hasSurge": false,
            "sla": {
                "restaurantId": "465641",
                "deliveryTime": 29,
                "minDeliveryTime": 29,
                "maxDeliveryTime": 29,
                "lastMileTravel": 4.599999904632568,
                "lastMileDistance": 0,
                "serviceability": "SERVICEABLE",
                "rainMode": "NONE",
                "longDistance": "NOT_LONG_DISTANCE",
                "preferentialService": false,
                "iconType": "EMPTY"
            },
            "promoted": false,
            "avgRating": "3.8",
            "totalRatings": 50,
            "new": false
        },
        "subtype": "basic"
},
{
    
        "type": "restaurant",
        "data": {
            "type": "F",
            "id": "434894",
            "name": "Bacon Box B'B",
            "uuid": "f62055d6-7c45-46f1-9d86-7feb22cc2c6e",
            "city": "5",
            "area": "Kharghar",
            "totalRatingsString": "Too Few Ratings",
            "cloudinaryImageId": "lycvx6428fxsttxamlzw",
            "cuisines": [
                "Snacks"
            ],
            "tags": [
        
            ],
            "costForTwo": 25000,
            "costForTwoString": "₹250 FOR TWO",
            "deliveryTime": 29,
            "minDeliveryTime": 29,
            "maxDeliveryTime": 29,
            "slaString": "29 MINS",
            "lastMileTravel": 4.400000095367432,
            "slugs": {
                "restaurant": "bacon-box-b'b-kharghar-kharghar",
                "city": "mumbai"
            },
            "cityState": "5",
            "address": "Dhanashree CHS, Kharghar Gram Panchayat Rd, Block G, Sector 13, Kharghar, Navi Mumbai, Maharashtra 410210, India",
            "locality": "Sector 13",
            "parentId": 262471,
            "unserviceable": false,
            "veg": false,
            "select": false,
            "favorite": false,
            "tradeCampaignHeaders": [
        
            ],
            "aggregatedDiscountInfo": {
                "header": "50% off",
                "shortDescriptionList": [
                    {
                        "meta": "50% off | Use WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "descriptionList": [
                    {
                        "meta": "50% off up to ₹100 | Use code WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "subHeader": "",
                "headerType": 0,
                "superFreedel": ""
            },
            "aggregatedDiscountInfoV2": {
                "header": "50% OFF",
                "shortDescriptionList": [
                    {
                        "meta": "Use WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "descriptionList": [
                    {
                        "meta": "50% off up to ₹100 | Use code WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "subHeader": "",
                "headerType": 0,
                "superFreedel": ""
            },
            "chain": [
        
            ],
            "feeDetails": {
                "fees": [
          
                ],
                "totalFees": 0,
                "message": "",
                "title": "",
                "amount": "",
                "icon": ""
            },
            "availability": {
                "opened": true,
                "nextOpenMessage": "",
                "nextCloseMessage": ""
            },
            "longDistanceEnabled": 0,
            "rainMode": "NONE",
            "thirdPartyAddress": false,
            "thirdPartyVendor": "",
            "adTrackingID": "",
            "badges": {
                "imageBased": [
          
                ],
                "textBased": [
          
                ],
                "textExtendedBadges": [
          
                ]
            },
            "lastMileTravelString": "4.4 kms",
            "hasSurge": false,
            "sla": {
                "restaurantId": "434894",
                "deliveryTime": 29,
                "minDeliveryTime": 29,
                "maxDeliveryTime": 29,
                "lastMileTravel": 4.400000095367432,
                "lastMileDistance": 0,
                "serviceability": "SERVICEABLE",
                "rainMode": "NONE",
                "longDistance": "NOT_LONG_DISTANCE",
                "preferentialService": false,
                "iconType": "EMPTY"
            },
            "promoted": false,
            "avgRating": "--",
            "totalRatings": 0,
            "new": false
        },
        "subtype": "basic"
},
{
        "type": "restaurant",
        "data": {
            "type": "F",
            "id": "28911",
            "name": "Cheelizza - India ka Pizza",
            "uuid": "5a0443b9-0670-4f23-9b0c-67bb45d44a9a",
            "city": "5",
            "area": "Kharghar",
            "totalRatingsString": "500+ ratings",
            "cloudinaryImageId": "ygmuskyroigxnw5xil3z",
            "cuisines": [
                "Pizzas",
                "Italian",
                "Desserts",
                "Beverages"
            ],
            "tags": [
        
            ],
            "costForTwo": 50000,
            "costForTwoString": "₹500 FOR TWO",
            "deliveryTime": 27,
            "minDeliveryTime": 27,
            "maxDeliveryTime": 27,
            "slaString": "27 MINS",
            "lastMileTravel": 4.800000190734863,
            "slugs": {
                "restaurant": "cheelizza-kharghar-kharghar",
                "city": "mumbai"
            },
            "cityState": "5",
            "address": "Shop 1A, Plot 184, Haawre Tiara Shopping Complex, Raghunath Vihar, Sector 13, Kharghar, Navi Mumbai",
            "locality": "Raghunath Vihar",
            "parentId": 375077,
            "unserviceable": false,
            "veg": true,
            "select": false,
            "favorite": false,
            "tradeCampaignHeaders": [
        
            ],
            "aggregatedDiscountInfo": {
                "header": "60% off",
                "shortDescriptionList": [
                    {
                        "meta": "60% off | Use SPECIALS",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "descriptionList": [
                    {
                        "meta": "60% off up to ₹120 on select items | Use code SPECIALS",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "subHeader": "",
                "headerType": 0,
                "superFreedel": ""
            },
            "aggregatedDiscountInfoV2": {
                "header": "60% OFF",
                "shortDescriptionList": [
                    {
                        "meta": "Use SPECIALS",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "descriptionList": [
                    {
                        "meta": "60% off up to ₹120 on select items | Use code SPECIALS",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "subHeader": "",
                "headerType": 0,
                "superFreedel": ""
            },
            "chain": [
        
            ],
            "feeDetails": {
                "fees": [
          
                ],
                "totalFees": 0,
                "message": "",
                "title": "",
                "amount": "",
                "icon": ""
            },
            "availability": {
                "opened": true,
                "nextOpenMessage": "",
                "nextCloseMessage": ""
            },
            "longDistanceEnabled": 0,
            "rainMode": "NONE",
            "thirdPartyAddress": false,
            "thirdPartyVendor": "",
            "adTrackingID": "",
            "badges": {
                "imageBased": [
          
                ],
                "textBased": [
          
                ],
                "textExtendedBadges": [
          
                ]
            },
            "lastMileTravelString": "4.8 kms",
            "hasSurge": false,
            "sla": {
                "restaurantId": "28911",
                "deliveryTime": 27,
                "minDeliveryTime": 27,
                "maxDeliveryTime": 27,
                "lastMileTravel": 4.800000190734863,
                "lastMileDistance": 0,
                "serviceability": "SERVICEABLE",
                "rainMode": "NONE",
                "longDistance": "NOT_LONG_DISTANCE",
                "preferentialService": false,
                "iconType": "EMPTY"
            },
            "promoted": false,
            "avgRating": "4.1",
            "totalRatings": 500,
            "new": false
        },
        "subtype": "basic"
},
{
        "type": "restaurant",
        "data": {
            "type": "F",
            "id": "386021",
            "name": "Chakna chat Namkeen",
            "uuid": "20aed53b-0720-43ce-817c-367fe87d860b",
            "city": "5",
            "area": "Kharghar",
            "totalRatingsString": "Too Few Ratings",
            "cloudinaryImageId": "qwtf5xjm3sc8kpdp1wga",
            "cuisines": [
                "Indian"
            ],
            "tags": [
        
            ],
            "costForTwo": 30000,
            "costForTwoString": "₹300 FOR TWO",
            "deliveryTime": 23,
            "minDeliveryTime": 23,
            "maxDeliveryTime": 23,
            "slaString": "23 MINS",
            "lastMileTravel": 4.400000095367432,
            "slugs": {
                "restaurant": "chakna-chat-namkeen-kharghar-kharghar",
                "city": "mumbai"
            },
            "cityState": "5",
            "address": "Dhanashree CHS, Kharghar Gram Panchayat Rd, Block G, Sector 13, Kharghar, Navi Mumbai, Maharashtra 410210, India",
            "locality": "Sector 13",
            "parentId": 243399,
            "unserviceable": false,
            "veg": false,
            "select": false,
            "favorite": false,
            "tradeCampaignHeaders": [
        
            ],
            "aggregatedDiscountInfo": {
                "header": "50% off",
                "shortDescriptionList": [
                    {
                        "meta": "50% off | Use WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "descriptionList": [
                    {
                        "meta": "50% off up to ₹100 | Use code WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "subHeader": "",
                "headerType": 0,
                "superFreedel": ""
            },
            "aggregatedDiscountInfoV2": {
                "header": "50% OFF",
                "shortDescriptionList": [
                    {
                        "meta": "Use WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "descriptionList": [
                    {
                        "meta": "50% off up to ₹100 | Use code WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "subHeader": "",
                "headerType": 0,
                "superFreedel": ""
            },
            "chain": [
        
            ],
            "feeDetails": {
                "fees": [
          
                ],
                "totalFees": 0,
                "message": "",
                "title": "",
                "amount": "",
                "icon": ""
            },
            "availability": {
                "opened": true,
                "nextOpenMessage": "",
                "nextCloseMessage": ""
            },
            "longDistanceEnabled": 0,
            "rainMode": "NONE",
            "thirdPartyAddress": false,
            "thirdPartyVendor": "",
            "adTrackingID": "",
            "badges": {
                "imageBased": [
          
                ],
                "textBased": [
          
                ],
                "textExtendedBadges": [
          
                ]
            },
            "lastMileTravelString": "4.4 kms",
            "hasSurge": false,
            "sla": {
                "restaurantId": "386021",
                "deliveryTime": 23,
                "minDeliveryTime": 23,
                "maxDeliveryTime": 23,
                "lastMileTravel": 4.400000095367432,
                "lastMileDistance": 0,
                "serviceability": "SERVICEABLE",
                "rainMode": "NONE",
                "longDistance": "NOT_LONG_DISTANCE",
                "preferentialService": false,
                "iconType": "EMPTY"
            },
            "promoted": false,
            "avgRating": "--",
            "totalRatings": 0,
            "new": false
        },
        "subtype": "basic"
},
{
        "type": "restaurant",
        "data": {
            "type": "F",
            "id": "575832",
            "name": "Malwani lunch",
            "uuid": "0365dff9-b209-47f3-9957-da02ef871b01",
            "city": "5",
            "area": "Kharghar",
            "totalRatingsString": "50+ ratings",
            "cloudinaryImageId": "pseocromntzpsugwlesh",
            "cuisines": [
                "North Indian",
                "Chinese",
                "Tandoor",
                "Biryani",
                "Snacks"
            ],
            "tags": [
        
            ],
            "costForTwo": 20000,
            "costForTwoString": "₹200 FOR TWO",
            "deliveryTime": 31,
            "minDeliveryTime": 31,
            "maxDeliveryTime": 31,
            "slaString": "31 MINS",
            "lastMileTravel": 4.599999904632568,
            "slugs": {
                "restaurant": "the-tent-house-kharghar-kharghar",
                "city": "mumbai"
            },
            "cityState": "5",
            "address": "shop no.21, plot no.28, ground floor, bhoomi tower sector 4 kharghar panvel - 410210",
            "locality": "Bhoomi Tower",
            "parentId": 351323,
            "unserviceable": false,
            "veg": false,
            "select": false,
            "favorite": false,
            "tradeCampaignHeaders": [
        
            ],
            "aggregatedDiscountInfo": {
                "header": "50% off",
                "shortDescriptionList": [
                    {
                        "meta": "50% off | Use WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "descriptionList": [
                    {
                        "meta": "50% off up to ₹100 | Use code WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "subHeader": "",
                "headerType": 0,
                "superFreedel": ""
            },
            "aggregatedDiscountInfoV2": {
                "header": "50% OFF",
                "shortDescriptionList": [
                    {
                        "meta": "Use WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "descriptionList": [
                    {
                        "meta": "50% off up to ₹100 | Use code WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "subHeader": "",
                "headerType": 0,
                "superFreedel": ""
            },
            "chain": [
        
            ],
            "feeDetails": {
                "fees": [
          
                ],
                "totalFees": 0,
                "message": "",
                "title": "",
                "amount": "",
                "icon": ""
            },
            "availability": {
                "opened": true,
                "nextOpenMessage": "",
                "nextCloseMessage": ""
            },
            "longDistanceEnabled": 0,
            "rainMode": "NONE",
            "thirdPartyAddress": false,
            "thirdPartyVendor": "",
            "adTrackingID": "",
            "badges": {
                "imageBased": [
          
                ],
                "textBased": [
          
                ],
                "textExtendedBadges": [
          
                ]
            },
            "lastMileTravelString": "4.5 kms",
            "hasSurge": false,
            "sla": {
                "restaurantId": "575832",
                "deliveryTime": 31,
                "minDeliveryTime": 31,
                "maxDeliveryTime": 31,
                "lastMileTravel": 4.599999904632568,
                "lastMileDistance": 0,
                "serviceability": "SERVICEABLE",
                "rainMode": "NONE",
                "longDistance": "NOT_LONG_DISTANCE",
                "preferentialService": false,
                "iconType": "EMPTY"
            },
            "promoted": false,
            "avgRating": "3.6",
            "totalRatings": 50,
            "new": false
        },
        "subtype": "basic"
},
{
        "type": "restaurant",
        "data": {
            "type": "F",
            "id": "359701",
            "name": "Keto Diet Meals! !K4E!",
            "uuid": "c0e0f3d8-22a9-4f90-a531-6c1435922418",
            "city": "5",
            "area": "Kharghar",
            "totalRatingsString": "Too Few Ratings",
            "cloudinaryImageId": "wurplannffxoqahpgheu",
            "cuisines": [
                "Healthy Food",
                "Salads"
            ],
            "tags": [
        
            ],
            "costForTwo": 30000,
            "costForTwoString": "₹300 FOR TWO",
            "deliveryTime": 29,
            "minDeliveryTime": 29,
            "maxDeliveryTime": 29,
            "slaString": "29 MINS",
            "lastMileTravel": 4.5,
            "slugs": {
                "restaurant": "keto-diet-meals!-!k4e!-kharghar-kharghar",
                "city": "mumbai"
            },
            "cityState": "5",
            "address": "SHOP NO-7 PLOT NO-146 DHANASHREE CHS, IN FORNT OF STAR MARKET , KAMDHENU SECTOR-13,KHARGHAR PIN CODE 410210",
            "locality": "Kamdhenu Sector-13",
            "parentId": 116675,
            "unserviceable": false,
            "veg": false,
            "select": false,
            "favorite": false,
            "tradeCampaignHeaders": [
        
            ],
            "aggregatedDiscountInfo": {
                "header": "50% off",
                "shortDescriptionList": [
                    {
                        "meta": "50% off | Use WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "descriptionList": [
                    {
                        "meta": "50% off up to ₹100 | Use code WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "subHeader": "",
                "headerType": 0,
                "superFreedel": ""
            },
            "aggregatedDiscountInfoV2": {
                "header": "50% OFF",
                "shortDescriptionList": [
                    {
                        "meta": "Use WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "descriptionList": [
                    {
                        "meta": "50% off up to ₹100 | Use code WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "subHeader": "",
                "headerType": 0,
                "superFreedel": ""
            },
            "chain": [
        
            ],
            "feeDetails": {
                "fees": [
          
                ],
                "totalFees": 0,
                "message": "",
                "title": "",
                "amount": "",
                "icon": ""
            },
            "availability": {
                "opened": true,
                "nextOpenMessage": "",
                "nextCloseMessage": ""
            },
            "longDistanceEnabled": 0,
            "rainMode": "NONE",
            "thirdPartyAddress": false,
            "thirdPartyVendor": "",
            "adTrackingID": "",
            "badges": {
                "imageBased": [
          
                ],
                "textBased": [
          
                ],
                "textExtendedBadges": [
          
                ]
            },
            "lastMileTravelString": "4.5 kms",
            "hasSurge": false,
            "sla": {
                "restaurantId": "359701",
                "deliveryTime": 29,
                "minDeliveryTime": 29,
                "maxDeliveryTime": 29,
                "lastMileTravel": 4.5,
                "lastMileDistance": 0,
                "serviceability": "SERVICEABLE",
                "rainMode": "NONE",
                "longDistance": "NOT_LONG_DISTANCE",
                "preferentialService": false,
                "iconType": "EMPTY"
            },
            "promoted": false,
            "avgRating": "--",
            "totalRatings": 0,
            "new": false
        },
        "subtype": "basic"
},
{
        "type": "restaurant",
        "data": {
            "type": "F",
            "id": "595929",
            "name": "Coffee Over Breakfast",
            "uuid": "f65584e9-bf04-415b-86ca-96256b54e52a",
            "city": "5",
            "area": "SECTOR 13 KHARGHAR",
            "totalRatingsString": "Too Few Ratings",
            "cloudinaryImageId": "gkemlh2lclk1g7lv96fc",
            "cuisines": [
                "Beverages",
                "Snacks",
                "Indian"
            ],
            "tags": [
        
            ],
            "costForTwo": 20000,
            "costForTwoString": "₹200 FOR TWO",
            "deliveryTime": 33,
            "minDeliveryTime": 33,
            "maxDeliveryTime": 33,
            "slaString": "33 MINS",
            "lastMileTravel": 4.400000095367432,
            "slugs": {
                "restaurant": "coffee-over-breakfast-jog-gor-west-jog-gor-west",
                "city": "mumbai"
            },
            "cityState": "5",
            "address": "SHOP NO. 3/4 AMEY CHS LTD. NEAR CHOURANG HIGHT SECTOR 13 KHARGHAR ,,Panvel (Rural),Raigad,Maharashtra-410210",
            "locality": "SECTOR 13 KHARGHAR",
            "parentId": 64403,
            "unserviceable": false,
            "veg": false,
            "select": false,
            "favorite": false,
            "tradeCampaignHeaders": [
        
            ],
            "aggregatedDiscountInfo": {
                "header": "50% off",
                "shortDescriptionList": [
                    {
                        "meta": "50% off | Use WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "descriptionList": [
                    {
                        "meta": "50% off up to ₹100 | Use code WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "subHeader": "",
                "headerType": 0,
                "superFreedel": ""
            },
            "aggregatedDiscountInfoV2": {
                "header": "50% OFF",
                "shortDescriptionList": [
                    {
                        "meta": "Use WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "descriptionList": [
                    {
                        "meta": "50% off up to ₹100 | Use code WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "subHeader": "",
                "headerType": 0,
                "superFreedel": ""
            },
            "chain": [
        
            ],
            "feeDetails": {
                "fees": [
          
                ],
                "totalFees": 0,
                "message": "",
                "title": "",
                "amount": "",
                "icon": ""
            },
            "availability": {
                "opened": true,
                "nextOpenMessage": "",
                "nextCloseMessage": ""
            },
            "longDistanceEnabled": 0,
            "rainMode": "NONE",
            "thirdPartyAddress": false,
            "thirdPartyVendor": "",
            "adTrackingID": "",
            "badges": {
                "imageBased": [
          
                ],
                "textBased": [
          
                ],
                "textExtendedBadges": [
          
                ]
            },
            "lastMileTravelString": "4.4 kms",
            "hasSurge": false,
            "sla": {
                "restaurantId": "595929",
                "deliveryTime": 33,
                "minDeliveryTime": 33,
                "maxDeliveryTime": 33,
                "lastMileTravel": 4.400000095367432,
                "lastMileDistance": 0,
                "serviceability": "SERVICEABLE",
                "rainMode": "NONE",
                "longDistance": "NOT_LONG_DISTANCE",
                "preferentialService": false,
                "iconType": "EMPTY"
            },
            "promoted": false,
            "avgRating": "--",
            "totalRatings": 0,
            "new": false
        },
        "subtype": "basic"
},
{
        "type": "restaurant",
        "data": {
            "type": "F",
            "id": "374059",
            "name": "Pizza Charm - Handcrafted Fresh Pan Pizza's",
            "uuid": "993b43b0-c1b2-444f-98eb-e43e096577f8",
            "city": "5",
            "area": "Kharghar Sector 4",
            "totalRatingsString": "20+ ratings",
            "cloudinaryImageId": "u2gskesktkycrgzqemzi",
            "cuisines": [
                "Pizzas",
                "Continental"
            ],
            "tags": [
        
            ],
            "costForTwo": 20000,
            "costForTwoString": "₹200 FOR TWO",
            "deliveryTime": 28,
            "minDeliveryTime": 28,
            "maxDeliveryTime": 28,
            "slaString": "28 MINS",
            "lastMileTravel": 4.599999904632568,
            "slugs": {
                "restaurant": "pizza-charm-kharghar-kharghar",
                "city": "mumbai"
            },
            "cityState": "5",
            "address": "Bhoomi Tower, Sector 4, Kharghar, Navi Mumbai, Maharashtra, India",
            "locality": "Kharghar",
            "parentId": 158440,
            "unserviceable": false,
            "veg": false,
            "select": false,
            "favorite": false,
            "tradeCampaignHeaders": [
        
            ],
            "aggregatedDiscountInfo": {
                "header": "50% off",
                "shortDescriptionList": [
                    {
                        "meta": "50% off | Use WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "descriptionList": [
                    {
                        "meta": "50% off up to ₹100 | Use code WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "subHeader": "",
                "headerType": 0,
                "superFreedel": ""
            },
            "aggregatedDiscountInfoV2": {
                "header": "50% OFF",
                "shortDescriptionList": [
                    {
                        "meta": "Use WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "descriptionList": [
                    {
                        "meta": "50% off up to ₹100 | Use code WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "subHeader": "",
                "headerType": 0,
                "superFreedel": ""
            },
            "chain": [
        
            ],
            "feeDetails": {
                "fees": [
          
                ],
                "totalFees": 0,
                "message": "",
                "title": "",
                "amount": "",
                "icon": ""
            },
            "availability": {
                "opened": true,
                "nextOpenMessage": "",
                "nextCloseMessage": ""
            },
            "longDistanceEnabled": 0,
            "rainMode": "NONE",
            "thirdPartyAddress": false,
            "thirdPartyVendor": "",
            "adTrackingID": "",
            "badges": {
                "imageBased": [
          
                ],
                "textBased": [
          
                ],
                "textExtendedBadges": [
          
                ]
            },
            "lastMileTravelString": "4.5 kms",
            "hasSurge": false,
            "sla": {
                "restaurantId": "374059",
                "deliveryTime": 28,
                "minDeliveryTime": 28,
                "maxDeliveryTime": 28,
                "lastMileTravel": 4.599999904632568,
                "lastMileDistance": 0,
                "serviceability": "SERVICEABLE",
                "rainMode": "NONE",
                "longDistance": "NOT_LONG_DISTANCE",
                "preferentialService": false,
                "iconType": "EMPTY"
            },
            "promoted": false,
            "avgRating": "4.3",
            "totalRatings": 20,
            "new": false
        },
        "subtype": "basic"
},
{
        "type": "restaurant",
        "data": {
            "type": "F",
            "id": "261105",
            "name": "Tibb's Frankie",
            "uuid": "c653b0df-cf4c-4d2b-b2db-7fc15b57bbe8",
            "city": "5",
            "area": "Kharghar",
            "totalRatingsString": "100+ ratings",
            "cloudinaryImageId": "beoss3hrxmjrmjycrnwr",
            "cuisines": [
                "Snacks",
                "Biryani",
                "North Indian",
                "Mexican",
                "Beverages"
            ],
            "tags": [
        
            ],
            "costForTwo": 20000,
            "costForTwoString": "₹200 FOR TWO",
            "deliveryTime": 25,
            "minDeliveryTime": 25,
            "maxDeliveryTime": 25,
            "slaString": "25 MINS",
            "lastMileTravel": 4.699999809265137,
            "slugs": {
                "restaurant": "tibbs-frankie-kharghar-kharghar",
                "city": "mumbai"
            },
            "cityState": "5",
            "address": "SHOP NO.36,BHUMI TOWER, SECTOR 4 , PLOT NO.28, NEAR ITM COLLEGE,KHARGHAR,NAVI MUMBAI 410210",
            "locality": "Sector 4",
            "parentId": 216056,
            "unserviceable": false,
            "veg": false,
            "select": false,
            "favorite": false,
            "tradeCampaignHeaders": [
        
            ],
            "aggregatedDiscountInfo": {
                "header": "60% off",
                "shortDescriptionList": [
                    {
                        "meta": "60% off | Use SPECIALS",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "descriptionList": [
                    {
                        "meta": "60% off up to ₹120 on select items | Use code SPECIALS",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "subHeader": "",
                "headerType": 0,
                "superFreedel": ""
            },
            "aggregatedDiscountInfoV2": {
                "header": "60% OFF",
                "shortDescriptionList": [
                    {
                        "meta": "Use SPECIALS",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "descriptionList": [
                    {
                        "meta": "60% off up to ₹120 on select items | Use code SPECIALS",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "subHeader": "",
                "headerType": 0,
                "superFreedel": ""
            },
            "chain": [
        
            ],
            "feeDetails": {
                "fees": [
          
                ],
                "totalFees": 0,
                "message": "",
                "title": "",
                "amount": "",
                "icon": ""
            },
            "availability": {
                "opened": true,
                "nextOpenMessage": "",
                "nextCloseMessage": ""
            },
            "longDistanceEnabled": 0,
            "rainMode": "NONE",
            "thirdPartyAddress": false,
            "thirdPartyVendor": "",
            "adTrackingID": "",
            "badges": {
                "imageBased": [
          
                ],
                "textBased": [
          
                ],
                "textExtendedBadges": [
          
                ]
            },
            "lastMileTravelString": "4.6 kms",
            "hasSurge": false,
            "sla": {
                "restaurantId": "261105",
                "deliveryTime": 25,
                "minDeliveryTime": 25,
                "maxDeliveryTime": 25,
                "lastMileTravel": 4.699999809265137,
                "lastMileDistance": 0,
                "serviceability": "SERVICEABLE",
                "rainMode": "NONE",
                "longDistance": "NOT_LONG_DISTANCE",
                "preferentialService": false,
                "iconType": "EMPTY"
            },
            "promoted": false,
            "avgRating": "4.1",
            "totalRatings": 100,
            "new": false
        },
        "subtype": "basic"
},
{
        "type": "restaurant",
        "data": {
            "type": "F",
            "id": "535343",
            "name": "Keto Helthy Meals Deit! K4E",
            "uuid": "1d6fd597-872d-45ca-aff4-91955e8d9c6f",
            "city": "5",
            "area": "SECTOR 13 KHARGHAR",
            "totalRatingsString": "Too Few Ratings",
            "cloudinaryImageId": "q5xfql1selrgkrnd1rq7",
            "cuisines": [
                "Beverages",
                "Juices",
                "Snacks"
            ],
            "tags": [
        
            ],
            "costForTwo": 25000,
            "costForTwoString": "₹250 FOR TWO",
            "deliveryTime": 33,
            "minDeliveryTime": 33,
            "maxDeliveryTime": 33,
            "slaString": "33 MINS",
            "lastMileTravel": 4.400000095367432,
            "slugs": {
                "restaurant": "keto-helthy-meals-deit!-k4e-andheri-west-andheri-west",
                "city": "mumbai"
            },
            "cityState": "5",
            "address": "SHOP NO. 3/4 AMEY CHS LTD. NEAR CHOURANG HIGHT SECTOR 13 KHARGHAR ,,Panvel (Rural),Raigad,Maharashtra-410210",
            "locality": "SECTOR 13 KHARGHAR",
            "parentId": 321655,
            "unserviceable": false,
            "veg": false,
            "select": false,
            "favorite": false,
            "tradeCampaignHeaders": [
        
            ],
            "aggregatedDiscountInfo": {
                "header": "50% off",
                "shortDescriptionList": [
                    {
                        "meta": "50% off | Use WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "descriptionList": [
                    {
                        "meta": "50% off up to ₹100 | Use code WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "subHeader": "",
                "headerType": 0,
                "superFreedel": ""
            },
            "aggregatedDiscountInfoV2": {
                "header": "50% OFF",
                "shortDescriptionList": [
                    {
                        "meta": "Use WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "descriptionList": [
                    {
                        "meta": "50% off up to ₹100 | Use code WELCOME50",
                        "discountType": "Percentage",
                        "operationType": "RESTAURANT"
                    }
                ],
                "subHeader": "",
                "headerType": 0,
                "superFreedel": ""
            },
            "chain": [
        
            ],
            "feeDetails": {
                "fees": [
          
                ],
                "totalFees": 0,
                "message": "",
                "title": "",
                "amount": "",
                "icon": ""
            },
            "availability": {
                "opened": true,
                "nextOpenMessage": "",
                "nextCloseMessage": ""
            },
            "longDistanceEnabled": 0,
            "rainMode": "NONE",
            "thirdPartyAddress": false,
            "thirdPartyVendor": "",
            "adTrackingID": "",
            "badges": {
                "imageBased": [
          
                ],
                "textBased": [
          
                ],
                "textExtendedBadges": [
          
                ]
            },
            "lastMileTravelString": "4.4 kms",
            "hasSurge": false,
            "sla": {
                "restaurantId": "535343",
                "deliveryTime": 33,
                "minDeliveryTime": 33,
                "maxDeliveryTime": 33,
                "lastMileTravel": 4.400000095367432,
                "lastMileDistance": 0,
                "serviceability": "SERVICEABLE",
                "rainMode": "NONE",
                "longDistance": "NOT_LONG_DISTANCE",
                "preferentialService": false,
                "iconType": "EMPTY"
            },
            "promoted": false,
            "avgRating": "--",
            "totalRatings": 0,
            "new": false
        },
        "subtype": "basic"
  },
  {"type": "restaurant",
  "data": {
    "type": "F",
    "id": "465641",
    "name": "The Tent House Restaurant",
    "uuid": "c232c0d4-d093-433d-b620-da532601c690",
    "city": "5",
    "area": "Bhoomi Tower",
    "totalRatingsString": "50+ ratings",
    "cloudinaryImageId": "wxmgg3jhayx7kyxwzjsv",
    "cuisines": [
      "North Indian",
      "Chinese",
      "Biryani"
    ],
    "tags": [
      
    ],
    "costForTwo": 20000,
    "costForTwoString": "₹200 FOR TWO",
    "deliveryTime": 31,
    "minDeliveryTime": 31,
    "maxDeliveryTime": 31,
    "slaString": "31 MINS",
    "lastMileTravel": 4.599999904632568,
    "slugs": {
      "restaurant": "the-tent-house-restaurant-kharghar-kharghar",
      "city": "mumbai"
    },
    "cityState": "5",
    "address": "SHOP NO. 21, PLOT NO. 28, GROUND FLOOR,, BHOOMI TOWER, SECTOR 4,KHARGHAR,PANVEL (RURAL),RAIGAD,MAHARASHTRA-410210",
    "locality": "Kharghar",
    "parentId": 279637,
    "unserviceable": false,
    "veg": false,
    "select": false,
    "favorite": false,
    "tradeCampaignHeaders": [
      
    ],
    "aggregatedDiscountInfo": {
      "header": "50% off",
      "shortDescriptionList": [
        {
          "meta": "50% off | Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "aggregatedDiscountInfoV2": {
      "header": "50% OFF",
      "shortDescriptionList": [
        {
          "meta": "Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "chain": [
      
    ],
    "feeDetails": {
      "fees": [
        
      ],
      "totalFees": 0,
      "message": "",
      "title": "",
      "amount": "",
      "icon": ""
    },
    "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
    },
    "longDistanceEnabled": 0,
    "rainMode": "NONE",
    "thirdPartyAddress": false,
    "thirdPartyVendor": "",
    "adTrackingID": "",
    "badges": {
      "imageBased": [
        
      ],
      "textBased": [
        
      ],
      "textExtendedBadges": [
        
      ]
    },
    "lastMileTravelString": "4.5 kms",
    "hasSurge": false,
    "sla": {
      "restaurantId": "465641",
      "deliveryTime": 31,
      "minDeliveryTime": 31,
      "maxDeliveryTime": 31,
      "lastMileTravel": 4.599999904632568,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
    },
    "promoted": false,
    "avgRating": "3.8",
    "totalRatings": 50,
    "new": false
  },
  "subtype": "basic"
},
{
  "type": "restaurant",
  "data": {
    "type": "F",
    "id": "434894",
    "name": "Bacon Box B'B",
    "uuid": "f62055d6-7c45-46f1-9d86-7feb22cc2c6e",
    "city": "5",
    "area": "Kharghar",
    "totalRatingsString": "Too Few Ratings",
    "cloudinaryImageId": "lycvx6428fxsttxamlzw",
    "cuisines": [
      "Snacks"
    ],
    "tags": [
      
    ],
    "costForTwo": 25000,
    "costForTwoString": "₹250 FOR TWO",
    "deliveryTime": 33,
    "minDeliveryTime": 33,
    "maxDeliveryTime": 33,
    "slaString": "33 MINS",
    "lastMileTravel": 4.400000095367432,
    "slugs": {
      "restaurant": "bacon-box-b'b-kharghar-kharghar",
      "city": "mumbai"
    },
    "cityState": "5",
    "address": "Dhanashree CHS, Kharghar Gram Panchayat Rd, Block G, Sector 13, Kharghar, Navi Mumbai, Maharashtra 410210, India",
    "locality": "Sector 13",
    "parentId": 262471,
    "unserviceable": false,
    "veg": false,
    "select": false,
    "favorite": false,
    "tradeCampaignHeaders": [
      
    ],
    "aggregatedDiscountInfo": {
      "header": "50% off",
      "shortDescriptionList": [
        {
          "meta": "50% off | Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "aggregatedDiscountInfoV2": {
      "header": "50% OFF",
      "shortDescriptionList": [
        {
          "meta": "Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "chain": [
      
    ],
    "feeDetails": {
      "fees": [
        
      ],
      "totalFees": 0,
      "message": "",
      "title": "",
      "amount": "",
      "icon": ""
    },
    "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
    },
    "longDistanceEnabled": 0,
    "rainMode": "NONE",
    "thirdPartyAddress": false,
    "thirdPartyVendor": "",
    "adTrackingID": "",
    "badges": {
      "imageBased": [
        
      ],
      "textBased": [
        
      ],
      "textExtendedBadges": [
        
      ]
    },
    "lastMileTravelString": "4.4 kms",
    "hasSurge": false,
    "sla": {
      "restaurantId": "434894",
      "deliveryTime": 33,
      "minDeliveryTime": 33,
      "maxDeliveryTime": 33,
      "lastMileTravel": 4.400000095367432,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
    },
    "promoted": false,
    "avgRating": "--",
    "totalRatings": 0,
    "new": false
  },
  "subtype": "basic"
},
{
  "type": "restaurant",
  "data": {
    "type": "F",
    "id": "28911",
    "name": "Cheelizza - India ka Pizza",
    "uuid": "5a0443b9-0670-4f23-9b0c-67bb45d44a9a",
    "city": "5",
    "area": "Kharghar",
    "totalRatingsString": "500+ ratings",
    "cloudinaryImageId": "ygmuskyroigxnw5xil3z",
    "cuisines": [
      "Pizzas",
      "Italian",
      "Desserts",
      "Beverages"
    ],
    "tags": [
      
    ],
    "costForTwo": 50000,
    "costForTwoString": "₹500 FOR TWO",
    "deliveryTime": 29,
    "minDeliveryTime": 29,
    "maxDeliveryTime": 29,
    "slaString": "29 MINS",
    "lastMileTravel": 4.800000190734863,
    "slugs": {
      "restaurant": "cheelizza-kharghar-kharghar",
      "city": "mumbai"
    },
    "cityState": "5",
    "address": "Shop 1A, Plot 184, Haawre Tiara Shopping Complex, Raghunath Vihar, Sector 13, Kharghar, Navi Mumbai",
    "locality": "Raghunath Vihar",
    "parentId": 375077,
    "unserviceable": false,
    "veg": true,
    "select": false,
    "favorite": false,
    "tradeCampaignHeaders": [
      
    ],
    "aggregatedDiscountInfo": {
      "header": "60% off",
      "shortDescriptionList": [
        {
          "meta": "60% off | Use SPECIALS",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "60% off up to ₹120 on select items | Use code SPECIALS",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "aggregatedDiscountInfoV2": {
      "header": "60% OFF",
      "shortDescriptionList": [
        {
          "meta": "Use SPECIALS",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "60% off up to ₹120 on select items | Use code SPECIALS",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "chain": [
      
    ],
    "feeDetails": {
      "fees": [
        
      ],
      "totalFees": 0,
      "message": "",
      "title": "",
      "amount": "",
      "icon": ""
    },
    "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
    },
    "longDistanceEnabled": 0,
    "rainMode": "NONE",
    "thirdPartyAddress": false,
    "thirdPartyVendor": "",
    "adTrackingID": "",
    "badges": {
      "imageBased": [
        
      ],
      "textBased": [
        
      ],
      "textExtendedBadges": [
        
      ]
    },
    "lastMileTravelString": "4.8 kms",
    "hasSurge": false,
    "sla": {
      "restaurantId": "28911",
      "deliveryTime": 29,
      "minDeliveryTime": 29,
      "maxDeliveryTime": 29,
      "lastMileTravel": 4.800000190734863,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
    },
    "promoted": false,
    "avgRating": "4.1",
    "totalRatings": 500,
    "new": false
  },
  "subtype": "basic"
},
{
  "type": "restaurant",
  "data": {
    "type": "F",
    "id": "386021",
    "name": "Chakna chat Namkeen",
    "uuid": "20aed53b-0720-43ce-817c-367fe87d860b",
    "city": "5",
    "area": "Kharghar",
    "totalRatingsString": "Too Few Ratings",
    "cloudinaryImageId": "qwtf5xjm3sc8kpdp1wga",
    "cuisines": [
      "Indian"
    ],
    "tags": [
      
    ],
    "costForTwo": 30000,
    "costForTwoString": "₹300 FOR TWO",
    "deliveryTime": 27,
    "minDeliveryTime": 27,
    "maxDeliveryTime": 27,
    "slaString": "27 MINS",
    "lastMileTravel": 4.400000095367432,
    "slugs": {
      "restaurant": "chakna-chat-namkeen-kharghar-kharghar",
      "city": "mumbai"
    },
    "cityState": "5",
    "address": "Dhanashree CHS, Kharghar Gram Panchayat Rd, Block G, Sector 13, Kharghar, Navi Mumbai, Maharashtra 410210, India",
    "locality": "Sector 13",
    "parentId": 243399,
    "unserviceable": false,
    "veg": false,
    "select": false,
    "favorite": false,
    "tradeCampaignHeaders": [
      
    ],
    "aggregatedDiscountInfo": {
      "header": "50% off",
      "shortDescriptionList": [
        {
          "meta": "50% off | Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "aggregatedDiscountInfoV2": {
      "header": "50% OFF",
      "shortDescriptionList": [
        {
          "meta": "Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "chain": [
      
    ],
    "feeDetails": {
      "fees": [
        
      ],
      "totalFees": 0,
      "message": "",
      "title": "",
      "amount": "",
      "icon": ""
    },
    "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
    },
    "longDistanceEnabled": 0,
    "rainMode": "NONE",
    "thirdPartyAddress": false,
    "thirdPartyVendor": "",
    "adTrackingID": "",
    "badges": {
      "imageBased": [
        
      ],
      "textBased": [
        
      ],
      "textExtendedBadges": [
        
      ]
    },
    "lastMileTravelString": "4.4 kms",
    "hasSurge": false,
    "sla": {
      "restaurantId": "386021",
      "deliveryTime": 27,
      "minDeliveryTime": 27,
      "maxDeliveryTime": 27,
      "lastMileTravel": 4.400000095367432,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
    },
    "promoted": false,
    "avgRating": "--",
    "totalRatings": 0,
    "new": false
  },
  "subtype": "basic"
},
{
  "type": "restaurant",
  "data": {
    "type": "F",
    "id": "575832",
    "name": "Malwani lunch",
    "uuid": "0365dff9-b209-47f3-9957-da02ef871b01",
    "city": "5",
    "area": "Kharghar",
    "totalRatingsString": "50+ ratings",
    "cloudinaryImageId": "pseocromntzpsugwlesh",
    "cuisines": [
      "North Indian",
      "Chinese",
      "Tandoor",
      "Biryani",
      "Snacks"
    ],
    "tags": [
      
    ],
    "costForTwo": 20000,
    "costForTwoString": "₹200 FOR TWO",
    "deliveryTime": 32,
    "minDeliveryTime": 32,
    "maxDeliveryTime": 32,
    "slaString": "32 MINS",
    "lastMileTravel": 4.599999904632568,
    "slugs": {
      "restaurant": "the-tent-house-kharghar-kharghar",
      "city": "mumbai"
    },
    "cityState": "5",
    "address": "shop no.21, plot no.28, ground floor, bhoomi tower sector 4 kharghar panvel - 410210",
    "locality": "Bhoomi Tower",
    "parentId": 351323,
    "unserviceable": false,
    "veg": false,
    "select": false,
    "favorite": false,
    "tradeCampaignHeaders": [
      
    ],
    "aggregatedDiscountInfo": {
      "header": "50% off",
      "shortDescriptionList": [
        {
          "meta": "50% off | Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "aggregatedDiscountInfoV2": {
      "header": "50% OFF",
      "shortDescriptionList": [
        {
          "meta": "Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "chain": [
      
    ],
    "feeDetails": {
      "fees": [
        
      ],
      "totalFees": 0,
      "message": "",
      "title": "",
      "amount": "",
      "icon": ""
    },
    "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
    },
    "longDistanceEnabled": 0,
    "rainMode": "NONE",
    "thirdPartyAddress": false,
    "thirdPartyVendor": "",
    "adTrackingID": "",
    "badges": {
      "imageBased": [
        
      ],
      "textBased": [
        
      ],
      "textExtendedBadges": [
        
      ]
    },
    "lastMileTravelString": "4.5 kms",
    "hasSurge": false,
    "sla": {
      "restaurantId": "575832",
      "deliveryTime": 32,
      "minDeliveryTime": 32,
      "maxDeliveryTime": 32,
      "lastMileTravel": 4.599999904632568,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
    },
    "promoted": false,
    "avgRating": "3.6",
    "totalRatings": 50,
    "new": false
  },
  "subtype": "basic"
},
{
  "type": "restaurant",
  "data": {
    "type": "F",
    "id": "359701",
    "name": "Keto Diet Meals! !K4E!",
    "uuid": "c0e0f3d8-22a9-4f90-a531-6c1435922418",
    "city": "5",
    "area": "Kharghar",
    "totalRatingsString": "Too Few Ratings",
    "cloudinaryImageId": "wurplannffxoqahpgheu",
    "cuisines": [
      "Healthy Food",
      "Salads"
    ],
    "tags": [
      
    ],
    "costForTwo": 30000,
    "costForTwoString": "₹300 FOR TWO",
    "deliveryTime": 32,
    "minDeliveryTime": 32,
    "maxDeliveryTime": 32,
    "slaString": "32 MINS",
    "lastMileTravel": 4.5,
    "slugs": {
      "restaurant": "keto-diet-meals!-!k4e!-kharghar-kharghar",
      "city": "mumbai"
    },
    "cityState": "5",
    "address": "SHOP NO-7 PLOT NO-146 DHANASHREE CHS, IN FORNT OF STAR MARKET , KAMDHENU SECTOR-13,KHARGHAR PIN CODE 410210",
    "locality": "Kamdhenu Sector-13",
    "parentId": 116675,
    "unserviceable": false,
    "veg": false,
    "select": false,
    "favorite": false,
    "tradeCampaignHeaders": [
      
    ],
    "aggregatedDiscountInfo": {
      "header": "50% off",
      "shortDescriptionList": [
        {
          "meta": "50% off | Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "aggregatedDiscountInfoV2": {
      "header": "50% OFF",
      "shortDescriptionList": [
        {
          "meta": "Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "chain": [
      
    ],
    "feeDetails": {
      "fees": [
        
      ],
      "totalFees": 0,
      "message": "",
      "title": "",
      "amount": "",
      "icon": ""
    },
    "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
    },
    "longDistanceEnabled": 0,
    "rainMode": "NONE",
    "thirdPartyAddress": false,
    "thirdPartyVendor": "",
    "adTrackingID": "",
    "badges": {
      "imageBased": [
        
      ],
      "textBased": [
        
      ],
      "textExtendedBadges": [
        
      ]
    },
    "lastMileTravelString": "4.5 kms",
    "hasSurge": false,
    "sla": {
      "restaurantId": "359701",
      "deliveryTime": 32,
      "minDeliveryTime": 32,
      "maxDeliveryTime": 32,
      "lastMileTravel": 4.5,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
    },
    "promoted": false,
    "avgRating": "--",
    "totalRatings": 0,
    "new": false
  },
  "subtype": "basic"
},
{
  "type": "restaurant",
  "data": {
    "type": "F",
    "id": "595929",
    "name": "Coffee Over Breakfast",
    "uuid": "f65584e9-bf04-415b-86ca-96256b54e52a",
    "city": "5",
    "area": "SECTOR 13 KHARGHAR",
    "totalRatingsString": "Too Few Ratings",
    "cloudinaryImageId": "gkemlh2lclk1g7lv96fc",
    "cuisines": [
      "Beverages",
      "Snacks",
      "Indian"
    ],
    "tags": [
      
    ],
    "costForTwo": 20000,
    "costForTwoString": "₹200 FOR TWO",
    "deliveryTime": 33,
    "minDeliveryTime": 33,
    "maxDeliveryTime": 33,
    "slaString": "33 MINS",
    "lastMileTravel": 4.400000095367432,
    "slugs": {
      "restaurant": "coffee-over-breakfast-jog-gor-west-jog-gor-west",
      "city": "mumbai"
    },
    "cityState": "5",
    "address": "SHOP NO. 3/4 AMEY CHS LTD. NEAR CHOURANG HIGHT SECTOR 13 KHARGHAR ,,Panvel (Rural),Raigad,Maharashtra-410210",
    "locality": "SECTOR 13 KHARGHAR",
    "parentId": 64403,
    "unserviceable": false,
    "veg": false,
    "select": false,
    "favorite": false,
    "tradeCampaignHeaders": [
      
    ],
    "aggregatedDiscountInfo": {
      "header": "50% off",
      "shortDescriptionList": [
        {
          "meta": "50% off | Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "aggregatedDiscountInfoV2": {
      "header": "50% OFF",
      "shortDescriptionList": [
        {
          "meta": "Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "chain": [
      
    ],
    "feeDetails": {
      "fees": [
        
      ],
      "totalFees": 0,
      "message": "",
      "title": "",
      "amount": "",
      "icon": ""
    },
    "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
    },
    "longDistanceEnabled": 0,
    "rainMode": "NONE",
    "thirdPartyAddress": false,
    "thirdPartyVendor": "",
    "adTrackingID": "",
    "badges": {
      "imageBased": [
        
      ],
      "textBased": [
        
      ],
      "textExtendedBadges": [
        
      ]
    },
    "lastMileTravelString": "4.4 kms",
    "hasSurge": false,
    "sla": {
      "restaurantId": "595929",
      "deliveryTime": 33,
      "minDeliveryTime": 33,
      "maxDeliveryTime": 33,
      "lastMileTravel": 4.400000095367432,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
    },
    "promoted": false,
    "avgRating": "--",
    "totalRatings": 0,
    "new": false
  },
  "subtype": "basic"
},
{
  "type": "restaurant",
  "data": {
    "type": "F",
    "id": "374059",
    "name": "Pizza Charm - Handcrafted Fresh Pan Pizza's",
    "uuid": "993b43b0-c1b2-444f-98eb-e43e096577f8",
    "city": "5",
    "area": "Kharghar Sector 4",
    "totalRatingsString": "20+ ratings",
    "cloudinaryImageId": "u2gskesktkycrgzqemzi",
    "cuisines": [
      "Pizzas",
      "Continental"
    ],
    "tags": [
      
    ],
    "costForTwo": 20000,
    "costForTwoString": "₹200 FOR TWO",
    "deliveryTime": 30,
    "minDeliveryTime": 30,
    "maxDeliveryTime": 30,
    "slaString": "30 MINS",
    "lastMileTravel": 4.599999904632568,
    "slugs": {
      "restaurant": "pizza-charm-kharghar-kharghar",
      "city": "mumbai"
    },
    "cityState": "5",
    "address": "Bhoomi Tower, Sector 4, Kharghar, Navi Mumbai, Maharashtra, India",
    "locality": "Kharghar",
    "parentId": 158440,
    "unserviceable": false,
    "veg": false,
    "select": false,
    "favorite": false,
    "tradeCampaignHeaders": [
      
    ],
    "aggregatedDiscountInfo": {
      "header": "50% off",
      "shortDescriptionList": [
        {
          "meta": "50% off | Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "aggregatedDiscountInfoV2": {
      "header": "50% OFF",
      "shortDescriptionList": [
        {
          "meta": "Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "chain": [
      
    ],
    "feeDetails": {
      "fees": [
        
      ],
      "totalFees": 0,
      "message": "",
      "title": "",
      "amount": "",
      "icon": ""
    },
    "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
    },
    "longDistanceEnabled": 0,
    "rainMode": "NONE",
    "thirdPartyAddress": false,
    "thirdPartyVendor": "",
    "adTrackingID": "",
    "badges": {
      "imageBased": [
        
      ],
      "textBased": [
        
      ],
      "textExtendedBadges": [
        
      ]
    },
    "lastMileTravelString": "4.5 kms",
    "hasSurge": false,
    "sla": {
      "restaurantId": "374059",
      "deliveryTime": 30,
      "minDeliveryTime": 30,
      "maxDeliveryTime": 30,
      "lastMileTravel": 4.599999904632568,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
    },
    "promoted": false,
    "avgRating": "4.3",
    "totalRatings": 20,
    "new": false
  },
  "subtype": "basic"
},
{
  "type": "restaurant",
  "data": {
    "type": "F",
    "id": "261105",
    "name": "Tibb's Frankie",
    "uuid": "c653b0df-cf4c-4d2b-b2db-7fc15b57bbe8",
    "city": "5",
    "area": "Kharghar",
    "totalRatingsString": "100+ ratings",
    "cloudinaryImageId": "beoss3hrxmjrmjycrnwr",
    "cuisines": [
      "Snacks",
      "Biryani",
      "North Indian",
      "Mexican",
      "Beverages"
    ],
    "tags": [
      
    ],
    "costForTwo": 20000,
    "costForTwoString": "₹200 FOR TWO",
    "deliveryTime": 26,
    "minDeliveryTime": 26,
    "maxDeliveryTime": 26,
    "slaString": "26 MINS",
    "lastMileTravel": 4.699999809265137,
    "slugs": {
      "restaurant": "tibbs-frankie-kharghar-kharghar",
      "city": "mumbai"
    },
    "cityState": "5",
    "address": "SHOP NO.36,BHUMI TOWER, SECTOR 4 , PLOT NO.28, NEAR ITM COLLEGE,KHARGHAR,NAVI MUMBAI 410210",
    "locality": "Sector 4",
    "parentId": 216056,
    "unserviceable": false,
    "veg": false,
    "select": false,
    "favorite": false,
    "tradeCampaignHeaders": [
      
    ],
    "aggregatedDiscountInfo": {
      "header": "60% off",
      "shortDescriptionList": [
        {
          "meta": "60% off | Use SPECIALS",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "60% off up to ₹120 on select items | Use code SPECIALS",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "aggregatedDiscountInfoV2": {
      "header": "60% OFF",
      "shortDescriptionList": [
        {
          "meta": "Use SPECIALS",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "60% off up to ₹120 on select items | Use code SPECIALS",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "chain": [
      
    ],
    "feeDetails": {
      "fees": [
        
      ],
      "totalFees": 0,
      "message": "",
      "title": "",
      "amount": "",
      "icon": ""
    },
    "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
    },
    "longDistanceEnabled": 0,
    "rainMode": "NONE",
    "thirdPartyAddress": false,
    "thirdPartyVendor": "",
    "adTrackingID": "",
    "badges": {
      "imageBased": [
        
      ],
      "textBased": [
        
      ],
      "textExtendedBadges": [
        
      ]
    },
    "lastMileTravelString": "4.6 kms",
    "hasSurge": false,
    "sla": {
      "restaurantId": "261105",
      "deliveryTime": 26,
      "minDeliveryTime": 26,
      "maxDeliveryTime": 26,
      "lastMileTravel": 4.699999809265137,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
    },
    "promoted": false,
    "avgRating": "4.1",
    "totalRatings": 100,
    "new": false
  },
  "subtype": "basic"
},
{
  "type": "restaurant",
  "data": {
    "type": "F",
    "id": "535343",
    "name": "Keto Helthy Meals Deit! K4E",
    "uuid": "1d6fd597-872d-45ca-aff4-91955e8d9c6f",
    "city": "5",
    "area": "SECTOR 13 KHARGHAR",
    "totalRatingsString": "Too Few Ratings",
    "cloudinaryImageId": "q5xfql1selrgkrnd1rq7",
    "cuisines": [
      "Beverages",
      "Juices",
      "Snacks"
    ],
    "tags": [
      
    ],
    "costForTwo": 25000,
    "costForTwoString": "₹250 FOR TWO",
    "deliveryTime": 33,
    "minDeliveryTime": 33,
    "maxDeliveryTime": 33,
    "slaString": "33 MINS",
    "lastMileTravel": 4.400000095367432,
    "slugs": {
      "restaurant": "keto-helthy-meals-deit!-k4e-andheri-west-andheri-west",
      "city": "mumbai"
    },
    "cityState": "5",
    "address": "SHOP NO. 3/4 AMEY CHS LTD. NEAR CHOURANG HIGHT SECTOR 13 KHARGHAR ,,Panvel (Rural),Raigad,Maharashtra-410210",
    "locality": "SECTOR 13 KHARGHAR",
    "parentId": 321655,
    "unserviceable": false,
    "veg": false,
    "select": false,
    "favorite": false,
    "tradeCampaignHeaders": [
      
    ],
    "aggregatedDiscountInfo": {
      "header": "50% off",
      "shortDescriptionList": [
        {
          "meta": "50% off | Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "aggregatedDiscountInfoV2": {
      "header": "50% OFF",
      "shortDescriptionList": [
        {
          "meta": "Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "chain": [
      
    ],
    "feeDetails": {
      "fees": [
        
      ],
      "totalFees": 0,
      "message": "",
      "title": "",
      "amount": "",
      "icon": ""
    },
    "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
    },
    "longDistanceEnabled": 0,
    "rainMode": "NONE",
    "thirdPartyAddress": false,
    "thirdPartyVendor": "",
    "adTrackingID": "",
    "badges": {
      "imageBased": [
        
      ],
      "textBased": [
        
      ],
      "textExtendedBadges": [
        
      ]
    },
    "lastMileTravelString": "4.4 kms",
    "hasSurge": false,
    "sla": {
      "restaurantId": "535343",
      "deliveryTime": 33,
      "minDeliveryTime": 33,
      "maxDeliveryTime": 33,
      "lastMileTravel": 4.400000095367432,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
    },
    "promoted": false,
    "avgRating": "--",
    "totalRatings": 0,
    "new": false
  },
  "subtype": "basic"
},
{
  "type": "restaurant",
  "data": {
    "type": "F",
    "id": "192354",
    "name": "McCafe by McDonald's",
    "uuid": "c0eff870-f1fd-4438-9d97-16ff6ed86111",
    "city": "5",
    "area": "Kharghar",
    "totalRatingsString": "Too Few Ratings",
    "cloudinaryImageId": "lpdqtnu6sbxymjglxn1k",
    "cuisines": [
      "American",
      "Beverages",
      "Desserts"
    ],
    "tags": [
      
    ],
    "costForTwo": 25000,
    "costForTwoString": "₹250 FOR TWO",
    "deliveryTime": 27,
    "minDeliveryTime": 27,
    "maxDeliveryTime": 27,
    "slaString": "27 MINS",
    "lastMileTravel": 4.5,
    "slugs": {
      "restaurant": "mccafe-by-mcdonalds-little-world-kharghar",
      "city": "mumbai"
    },
    "cityState": "5",
    "address": "Little World Mall, Shop No 13 and 14, Plot#21, Sector 2, Kharghar .Navi Mumbai-41",
    "locality": "Little World",
    "parentId": 8263,
    "unserviceable": false,
    "veg": false,
    "select": false,
    "favorite": false,
    "tradeCampaignHeaders": [
      
    ],
    "aggregatedDiscountInfo": {
      "header": "50% off",
      "shortDescriptionList": [
        {
          "meta": "50% off | Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "aggregatedDiscountInfoV2": {
      "header": "50% OFF",
      "shortDescriptionList": [
        {
          "meta": "Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "chain": [
      
    ],
    "feeDetails": {
      "fees": [
        
      ],
      "totalFees": 0,
      "message": "",
      "title": "",
      "amount": "",
      "icon": ""
    },
    "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": "Closes soon"
    },
    "longDistanceEnabled": 0,
    "rainMode": "NONE",
    "thirdPartyAddress": false,
    "thirdPartyVendor": "",
    "adTrackingID": "",
    "badges": {
      "imageBased": [
        
      ],
      "textBased": [
        
      ],
      "textExtendedBadges": [
        
      ]
    },
    "lastMileTravelString": "4.5 kms",
    "hasSurge": false,
    "sla": {
      "restaurantId": "192354",
      "deliveryTime": 27,
      "minDeliveryTime": 27,
      "maxDeliveryTime": 27,
      "lastMileTravel": 4.5,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
    },
    "promoted": false,
    "avgRating": "--",
    "totalRatings": 0,
    "new": false
  },
  "subtype": "basic"
},
{
  "type": "restaurant",
  "data": {
    "type": "F",
    "id": "496600",
    "name": "Fab Kitchen",
    "uuid": "53553eb0-e150-4e7e-90e1-af8acbb0ad82",
    "city": "5",
    "area": "Kharghar",
    "totalRatingsString": "20+ ratings",
    "cloudinaryImageId": "bpagqqxxzgqsvy7oyjvv",
    "cuisines": [
      "North Indian",
      "Mughlai",
      "Chinese"
    ],
    "tags": [
      
    ],
    "costForTwo": 20000,
    "costForTwoString": "₹200 FOR TWO",
    "deliveryTime": 30,
    "minDeliveryTime": 30,
    "maxDeliveryTime": 30,
    "slaString": "30 MINS",
    "lastMileTravel": 4.800000190734863,
    "slugs": {
      "restaurant": "fab-kitchen-kharghar-kharghar",
      "city": "mumbai"
    },
    "cityState": "5",
    "address": "SHOP NO 5A/6A, GOODWILL GARDEN, PLOT NO 15/16, SECTOR 8, KHARGHAR, Panvel (Rural), Raigad, Maharashtra - 410210",
    "locality": "Goodwill Garden",
    "parentId": 78101,
    "unserviceable": false,
    "veg": false,
    "select": false,
    "favorite": false,
    "tradeCampaignHeaders": [
      
    ],
    "aggregatedDiscountInfo": {
      "header": "50% off",
      "shortDescriptionList": [
        {
          "meta": "50% off | Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "aggregatedDiscountInfoV2": {
      "header": "50% OFF",
      "shortDescriptionList": [
        {
          "meta": "Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "chain": [
      
    ],
    "feeDetails": {
      "fees": [
        
      ],
      "totalFees": 0,
      "message": "",
      "title": "",
      "amount": "",
      "icon": ""
    },
    "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
    },
    "longDistanceEnabled": 0,
    "rainMode": "NONE",
    "thirdPartyAddress": false,
    "thirdPartyVendor": "",
    "adTrackingID": "",
    "badges": {
      "imageBased": [
        
      ],
      "textBased": [
        
      ],
      "textExtendedBadges": [
        
      ]
    },
    "lastMileTravelString": "4.8 kms",
    "hasSurge": false,
    "sla": {
      "restaurantId": "496600",
      "deliveryTime": 30,
      "minDeliveryTime": 30,
      "maxDeliveryTime": 30,
      "lastMileTravel": 4.800000190734863,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
    },
    "promoted": false,
    "avgRating": "3.8",
    "totalRatings": 20,
    "new": false
  },
  "subtype": "basic"
},
{
  "type": "restaurant",
  "data": {
    "type": "F",
    "id": "450097",
    "name": "Rich Rolls - Rolls Momos and Shakes",
    "uuid": "6ca5c89e-d435-4728-b0b7-795426cf1824",
    "city": "5",
    "area": "Near Nirmaya Hospital",
    "totalRatingsString": "Too Few Ratings",
    "cloudinaryImageId": "wmgusnw0x9kjajmttilq",
    "cuisines": [
      "Pizzas",
      "American",
      "Snacks",
      "Beverages"
    ],
    "tags": [
      
    ],
    "costForTwo": 22000,
    "costForTwoString": "₹220 FOR TWO",
    "deliveryTime": 33,
    "minDeliveryTime": 33,
    "maxDeliveryTime": 33,
    "slaString": "33 MINS",
    "lastMileTravel": 4.699999809265137,
    "slugs": {
      "restaurant": "rich-rolls-kharghar-kharghar",
      "city": "mumbai"
    },
    "cityState": "5",
    "address": "Shop 39, Bhumi Tower, near Nirmaya Hospital, Sector 4, Kharghar, Navi Mumbai, Maharashtra 410210, India",
    "locality": "Near Nirmaya Hospital",
    "parentId": 270719,
    "unserviceable": false,
    "veg": false,
    "select": false,
    "favorite": false,
    "tradeCampaignHeaders": [
      
    ],
    "aggregatedDiscountInfo": {
      "header": "50% off",
      "shortDescriptionList": [
        {
          "meta": "50% off | Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "aggregatedDiscountInfoV2": {
      "header": "50% OFF",
      "shortDescriptionList": [
        {
          "meta": "Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "chain": [
      
    ],
    "feeDetails": {
      "fees": [
        
      ],
      "totalFees": 0,
      "message": "",
      "title": "",
      "amount": "",
      "icon": ""
    },
    "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
    },
    "longDistanceEnabled": 0,
    "rainMode": "NONE",
    "thirdPartyAddress": false,
    "thirdPartyVendor": "",
    "adTrackingID": "",
    "badges": {
      "imageBased": [
        
      ],
      "textBased": [
        
      ],
      "textExtendedBadges": [
        
      ]
    },
    "lastMileTravelString": "4.6 kms",
    "hasSurge": false,
    "sla": {
      "restaurantId": "450097",
      "deliveryTime": 33,
      "minDeliveryTime": 33,
      "maxDeliveryTime": 33,
      "lastMileTravel": 4.699999809265137,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
    },
    "promoted": false,
    "avgRating": "--",
    "totalRatings": 0,
    "new": false
  },
  "subtype": "basic"
},
{
  "type": "restaurant",
  "data": {
    "type": "F",
    "id": "32619",
    "name": "Meraki",
    "uuid": "97945e1c-e5db-49e0-9c3b-0f11eeca1948",
    "city": "5",
    "area": "Kharghar",
    "totalRatingsString": "1000+ ratings",
    "cloudinaryImageId": "x1bcxkp8lctaeungngfy",
    "cuisines": [
      "Chinese",
      "Thai",
      "Asian"
    ],
    "tags": [
      
    ],
    "costForTwo": 50000,
    "costForTwoString": "₹500 FOR TWO",
    "deliveryTime": 30,
    "minDeliveryTime": 30,
    "maxDeliveryTime": 30,
    "slaString": "30 MINS",
    "lastMileTravel": 5,
    "slugs": {
      "restaurant": "meraki-kharghar-kharghar",
      "city": "mumbai"
    },
    "cityState": "5",
    "address": "16, Balaji Aangan, 1, Sector 3, Kharghar",
    "locality": "Sector 3",
    "parentId": 2356,
    "unserviceable": false,
    "veg": false,
    "select": false,
    "favorite": false,
    "tradeCampaignHeaders": [
      
    ],
    "aggregatedDiscountInfo": {
      "header": "50% off",
      "shortDescriptionList": [
        {
          "meta": "50% off | Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "aggregatedDiscountInfoV2": {
      "header": "50% OFF",
      "shortDescriptionList": [
        {
          "meta": "Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "chain": [
      
    ],
    "feeDetails": {
      "fees": [
        
      ],
      "totalFees": 0,
      "message": "",
      "title": "",
      "amount": "",
      "icon": ""
    },
    "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
    },
    "longDistanceEnabled": 0,
    "rainMode": "NONE",
    "thirdPartyAddress": false,
    "thirdPartyVendor": "",
    "adTrackingID": "",
    "badges": {
      "imageBased": [
        
      ],
      "textBased": [
        
      ],
      "textExtendedBadges": [
        
      ]
    },
    "lastMileTravelString": "5 kms",
    "hasSurge": false,
    "sla": {
      "restaurantId": "32619",
      "deliveryTime": 30,
      "minDeliveryTime": 30,
      "maxDeliveryTime": 30,
      "lastMileTravel": 5,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
    },
    "promoted": false,
    "avgRating": "4.1",
    "totalRatings": 1000,
    "new": false
  },
  "subtype": "basic"
},
{
  "type": "restaurant",
  "data": {
    "type": "F",
    "id": "652235",
    "name": "Jumboking Indian Burger",
    "uuid": "6a9cafc8-9bca-46f9-9911-ae753f32f5b0",
    "city": "5",
    "area": "Kharghar",
    "totalRatingsString": "Too Few Ratings",
    "cloudinaryImageId": "82f699fdbf4877d92ff41a7b3f95205d",
    "cuisines": [
      "Burgers",
      "Fast Food",
      "Beverages"
    ],
    "tags": [
      
    ],
    "costForTwo": 15000,
    "costForTwoString": "₹150 FOR TWO",
    "deliveryTime": 26,
    "minDeliveryTime": 26,
    "maxDeliveryTime": 26,
    "slaString": "26 MINS",
    "lastMileTravel": 5,
    "slugs": {
      "restaurant": "jumboking-indian-burger-kharghar-kharghar",
      "city": "mumbai"
    },
    "cityState": "5",
    "address": "SHOP NO. 28 S.N. PARK, NEAR BHARATI VIDHYAPEETH, PLOT NO. E2/E4 , SECTOR - 3, KHARGHAR",
    "locality": "Near Bharati",
    "parentId": 515,
    "unserviceable": false,
    "veg": true,
    "select": false,
    "favorite": false,
    "tradeCampaignHeaders": [
      
    ],
    "aggregatedDiscountInfo": {
      "header": "50% off",
      "shortDescriptionList": [
        {
          "meta": "50% off | Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "aggregatedDiscountInfoV2": {
      "header": "50% OFF",
      "shortDescriptionList": [
        {
          "meta": "Use WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "descriptionList": [
        {
          "meta": "50% off up to ₹100 | Use code WELCOME50",
          "discountType": "Percentage",
          "operationType": "RESTAURANT"
        }
      ],
      "subHeader": "",
      "headerType": 0,
      "superFreedel": ""
    },
    "chain": [
      
    ],
    "feeDetails": {
      "fees": [
        
      ],
      "totalFees": 0,
      "message": "",
      "title": "",
      "amount": "",
      "icon": ""
    },
    "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
    },
    "longDistanceEnabled": 0,
    "rainMode": "NONE",
    "thirdPartyAddress": false,
    "thirdPartyVendor": "",
    "adTrackingID": "",
    "badges": {
      "imageBased": [
        
      ],
      "textBased": [
        
      ],
      "textExtendedBadges": [
        
      ]
    },
    "lastMileTravelString": "5 kms",
    "hasSurge": false,
    "sla": {
      "restaurantId": "652235",
      "deliveryTime": 26,
      "minDeliveryTime": 26,
      "maxDeliveryTime": 26,
      "lastMileTravel": 5,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
    },
    "promoted": false,
    "avgRating": "--",
    "totalRatings": 0,
    "new": false
  },
  "subtype": "basic"
}
]
  
export default List;




